// For Unit test before fixed
// import {dbAccessor} from '@/utils/dbAccessor'
import * as dbAccessor from '@/utils/dbAccessor'
import {getNullFields, Logger, convertTimestampToDateInObj, addNumbers, toMoney, sortNoCase, deepEqual, getRandomIdByTime, arrayToObj} from '@/utils/tools'
import EmailBodyBuilder from '@/utils/EmailBodyBuilder'
import {getRatesConfig, updateInventoryPromise} from './warehouseHelper'
import { Announcement, PackageReportWarehouse, Package } from '@/orm'
import {AuditRecord} from './warehouseModel'
const initialState = {
  warehouseLimitedInfo: {},
  settingPromotions: [],
  warehouseOrganizations: [],
  warehouseBillings: [],
  warehouseAnnouncements: [],
  packageReports: [],
  abnormalPackages: [],
  historyAbnormalPackages: [],
  statistics: {},
  inboundTrackingCache: [],
  dailyInboundMap: new Map(),
  pickupRecords: [],
  overseaCustomersList: [],
  isInboundConfig: false,
  warehousePricingPlans: [],
  warehouseProducts: [],
  thirdPartyResources: [],
  waitingScanFormShipments: []
}

const state = Object.assign({}, initialState)

export const mutations = {
  reset_state (state) {
    for (let prop in state) {
      state[prop] = initialState[prop]
    }
  },
  setWarehouseLimitedInfo (state, payload) {
    state.warehouseLimitedInfo = payload
  },
  setSettingPromotions (state, payload) {
    state.settingPromotions = payload
  },
  setWarehouseOrganizations (state, payload) {
    state.warehouseOrganizations = payload
  },
  setWarehouseBillings (state, payload) {
    state.warehouseBillings = payload
  },
  setWarehouseAnnouncements (state, payload) {
    state.warehouseAnnouncements = payload
  },
  setPackageReports (state, payload) {
    state.packageReports = payload
  },
  setAbnormalPackages (state, payload) {
    state.abnormalPackages = payload
  },
  setWaitingScanFormShipments (state, payload) {
    state.waitingScanFormShipments = payload
  },
  setHistoryAbnormalPackages (state, payload) {
    state.historyAbnormalPackages = payload
  },
  setStatistics (state, payload) {
    state.statistics = payload
  },
  setWarehouseListed (state, payload) {
    state.warehouseLimitedInfo.isListed = payload
  },
  setTempSkus (state, payload) {
    state.tempSkus = payload
  },
  setInboundTrackingCache (state, payload) {
    state.inboundTrackingCache = payload
  },
  setDailyInboundMap (state, payload) {
    state.dailyInboundMap = payload
  },
  setPickupRecords (state, payload) {
    state.pickupRecords = payload
  },
  setOverseaUsersList (state, payload) {
    state.overseaCustomersList = payload
  },
  setIsInboundConfig (state, payload) {
    state.isInboundConfig = payload
  },
  setWarehousePricingPlans (state, payload) {
    state.warehousePricingPlans = payload
  },
  setWarehouseProducts (state, payload) {
    state.warehouseProducts = payload
  },
  setThirdPartyResources (state, payload) {
    state.thirdPartyResources = payload
  }
}

export const actions = {
  reset_state ({commit}) {
    commit('reset_state')
  },
  async loadWarehouseOrganizations ({commit, getters}) {
    if (!getters.activeWarehouse) {
      return
    }
    await new Promise((resolve, reject) => {
      let successFunc = (orgDocs) => {
        resolve()
        const featureInboundForecastPkg = []
        const featureInboundForecast = []
        const featureInboundForecastDropshipping = []
        let organizations = orgDocs.docs.map(doc => {
          let organization = convertTimestampToDateInObj(doc.data())
          let key = doc.id
          let {features = []} = organization
          features.includes('InboundForecastPkg') && featureInboundForecastPkg.push(key)
          features.includes('InboundForecast') && featureInboundForecast.push(key)
          features.includes('InboundForecastDropshipping') && featureInboundForecastDropshipping.push(key)
          return {key, ...organization}
        })
        organizations.push({
          organizationId: 'unknown',
          organizationKey: 'unknown',
          tenantName: 'unknown',
          key: 'unknown'
        })
        let warehouseInfo = getters.warehouseInfo || {}
        commit('setWarehouseInfo', {...warehouseInfo, featureInboundForecastPkg, featureInboundForecast, featureInboundForecastDropshipping})
        commit('setWarehouseOrganizations', organizations)
      }

      let errorFunc = (error) => {
        console.error(`Warehouse organization RT error`, error)
        reject(error)
      }

      let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['warehouses', getters.activeWarehouse, 'organizations'])
      commit('addTosubscribed', {warehouseOrganizations: unsubscribe})
    })
  },
  async loadWarehouseBillings ({commit, getters}) {
    if (!getters.activeWarehouse) {
      return
    }

    let successFunc = (billingDocs) => {
      let billings = billingDocs.docs.map(doc => {
        let billing = doc.data()
        let key = doc.id
        return {key, ...billing}
      })
      commit('setWarehouseBillings', billings)
    }

    let errorFunc = (error) => {
      console.error(`Warehouse billings RT error`, error)
      throw error
    }

    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['warehouses', getters.activeWarehouse, 'billings'])
    commit('addTosubscribed', {warehouseBillings: unsubscribe})
  },
  uploadItems ({commit, getters}, payload) {
    // ***************************************************
    // *********************** Alert *********************
    // Do not sort or filter the upload items in payload
    // ***************************************************
    // ***************************************************
    let allNullfields = payload.items.reduce((sum, item) => {
      let nullFields = getNullFields(item)
      sum = [...sum, ...nullFields]
      return sum
    }, [])
    if (allNullfields.length > 0) {
      let error = `payload contains null value property, upload packages canceled`
      console.error(error)
      return Promise.reject(Error(error))
    }

    Logger.log('uploadItems', payload)
    commit('setLoading', true)
    commit('clearError')
    const operator = getters.operator
    payload.activeWarehouse = getters.activeWarehouse
    payload.warehouseName = getters.warehouseName
    payload.workerKey = getters.uid
    payload.workerName = operator.name || operator.displayName || ''
    let items = payload.items.map(item => {
      let {flag, ...itemAttrs} = item
      itemAttrs.inboundFee = (getters.upcMap[item.upc] && getters.upcMap[item.upc]?.inboundFee) || 0
      itemAttrs.keywords = item.sku ? [item.upc, item.sku] : [item.upc]
      if (item.snArray && item.snArray.length > 0) (itemAttrs.keywords = [...itemAttrs.keywords, ...item.snArray])
      itemAttrs.keywords = [...itemAttrs.keywords, ...itemAttrs.trackings[0].barcode]
      itemAttrs.forecastQty && itemAttrs.keywords.push('FORECAST')
      return itemAttrs
    })
    return dbAccessor.callFunction('uploadPackages', {...payload, items})
      .then((packagesUploaded) => {
        commit('setLoading', false)
        if (packagesUploaded) return packagesUploaded.data
      })
      .catch(error => {
        // tell UI function call failed. No change to payload
        // this could be the network issue which may cause duplicate data
        // commit('setError', error)
        commit('setLoading', false)
        throw error
      })
  },
  uploadItemsForBoxInventory ({commit, getters}, payload) {
    // ***************************************************
    // *********************** Alert *********************
    // Do not sort or filter the upload items in payload
    // ***************************************************
    // ***************************************************
    
    let allNullfields = payload.items.reduce((sum, item) => {
      let nullFields = getNullFields(item)
      sum = [...sum, ...nullFields]
      return sum
    }, [])
    if (allNullfields.length > 0) {
      let error = `payload contains null value property, upload packages canceled`
      console.error(error)
      return Promise.reject(Error(error))
    }

    Logger.log('uploadItems', payload)
    commit('setLoading', true)
    commit('clearError')
    const operator = getters.operator
    payload.activeWarehouse = getters.activeWarehouse
    payload.warehouseName = getters.warehouseName
    payload.workerKey = getters.uid
    payload.workerName = operator.name
    let items = payload.items.map(item => {
      let {flag, ...itemAttrs} = item
      itemAttrs.keywords = item.sku ? [item.upc, item.sku] : [item.upc]
      if (item.snArray && item.snArray.length > 0) (itemAttrs.keywords = [...itemAttrs.keywords, ...item.snArray])
      itemAttrs.keywords = [...itemAttrs.keywords, ...itemAttrs.trackings[0].barcode]
      itemAttrs.forecastDocKey && itemAttrs.keywords.push(itemAttrs.forecastDocKey)
      itemAttrs.forecastQty && itemAttrs.keywords.push('BOX_INVENTORY')
      return itemAttrs
    })
    return dbAccessor.callFunction('uploadPackageForBoxInventory', {...payload, items})
      .then((packagesUploaded) => {
        commit('setLoading', false)
        if (packagesUploaded) return packagesUploaded.data
      })
      .catch(error => {
        // tell UI function call failed. No change to payload
        // this could be the network issue which may cause duplicate data
        // commit('setError', error)
        commit('setLoading', false)
        throw error
      })
  },
  updatePackagesInfo ({commit, getters}, payload) {
    let allNullfieldsOld = payload.oldPackages.reduce((sum, item) => {
      let nullFields = getNullFields(item)
      sum = [...sum, ...nullFields]
      return sum
    }, [])
    let allNullfieldsNew = payload.newPackages.reduce((sum, item) => {
      let nullFields = getNullFields(item)
      sum = [...sum, ...nullFields]
      return sum
    }, [])
    if (allNullfieldsOld.length > 0 || allNullfieldsNew.length > 0) {
      let error = `payload contains null value property, update package org id canceled`
      console.error(error)
      return Promise.reject(Error(error))
    }
    Logger.log('updatePackagesInfo', payload)
    commit('setLoading', true)
    commit('clearError')
    return dbAccessor.callFunction('updatePackagesInfo', {
      ...payload,
      warehouseKey: getters.activeWarehouse,
      warehouseName: getters.warehouseName,
      uid: getters.uid,
      operatorId: getters.operator.uid,
      operatorName: getters.operator.name,
      userName: getters.userExtra.name,
      type: payload.type
    })
      .then(({data}) => {
        commit('setLoading', false)
        if (data.hasConfirmedPkg) {
          return data.newPkgs
        } else {
          return null
        }
      })
      .catch(error => {
        commit('setError', error)
        commit('setLoading', false)
        Logger.critical('update-pkg-info-error', payload, error)
        throw error
      })
  },
  deletePackage ({commit, getters}, payload) {
    return dbAccessor.runInTransactionStore(async transaction => {
      let pkgDoc = await transaction.get(dbAccessor.buildStoreQuery(['warehouses', getters.activeWarehouse || getters.activeOrganization, 'packages', payload._key]))
      let {createTime} = pkgDoc.data()
      transaction.update(pkgDoc.ref, {originCreateTime: createTime, createTime: dbAccessor.deleteField()})
    })
      .then(() => {
        Logger.changeLog({
          beforeValue: payload.getData(),
          actionPayload: {key: payload._key},
          actionName: 'deletePackage',
          categories: ['inventory'],
          keys: [payload._key],
          keywords: [payload._key],
          warehouseKey: getters.activeWarehouse
        })
      })
  },
  removePackage ({commit, getters}, payload) {
    let {_key, key} = payload
    let data = payload.getData ? payload.getData() : payload

    if (payload.isAddedToInventory) {
      let targetProduct = getters.productsWithUpcChangeableFlag.find(item => item.upc === payload.upc) || {}
      let targetDist = targetProduct.distribution[`warehouse${targetProduct.id}${Buffer.from(payload.siteName).toString('base64')}`]
      if (!targetProduct || !targetDist || targetDist.quantity - payload.quantity < 0) {
        if (!confirm('The inventory quantity will be negative, do you want to continue?')) return Promise.resolve('cancel')
      }
    }

    return dbAccessor.removeStore('warehouses', getters.activeOrganization, 'packages', _key || key)
      .then(() => {
        if (payload.isAddedToInventory) {
          return updateInventoryPromise([payload], getters.activeOrganization, getters.userExtra.name, '', '', true, true)
        }
        return Promise.resolve()
      })
      .then(() => {
        return Logger.changeLog({
          beforeValue: data,
          actionPayload: data,
          actionName: 'removePackage',
          categories: ['inventory'],
          keys: [_key || key],
          keywords: [_key || key, payload.organizationKey, ...payload.trackings, payload.upc]
        })
      })
  },
  async addUserToWarehouse ({commit, getters, dispatch}, payload) {
    // is there security risk?
    const { userExtra, activeWarehouse } = getters
    let predicates = [{
      field: 'email',
      compare: '==',
      value: payload.email
    }]
    let docs = await dbAccessor.queryWithPredicatesStore(predicates, 'users')

    if (docs.size === 0) {
      throw Error('Email address not found.')
    }
    const userDoc = docs.docs[0]
    const { name, warehouses = [], organizations = [], accounts = [], role } = userDoc.data()
    if (role !== 1) throw Error('Only individuals can be staff of the company.')
    if (accounts.length >= 10) {
      throw Error('He became an staff(member) of up to ten companies, cannot add.')
    }
    let userPayload = {
      warehouses: [activeWarehouse],
      accounts: dbAccessor.fieldValue().arrayUnion({
        email: userExtra.email,
        name: userExtra.name,
        key: activeWarehouse,
        role: userExtra.role,
        roles: payload.roles
      })
    }
    if (warehouses.length && !accounts.length) {
      const {users = [], name: warehousesName} = (await dbAccessor.queryStore('warehouses', warehouses[0])).data()
      let warehousesInfo = users.find(user => user.name === warehousesName)
      userPayload = {
        accounts: [
          {
            email: warehousesInfo.email,
            name: warehousesInfo.name,
            key: warehouses[0],
            role: 2,
            roles: warehousesInfo.roles
          },
          {
            email: userExtra.email,
            name: userExtra.name,
            key: activeWarehouse,
            role: userExtra.role,
            roles: payload.roles
          }]
      }
    }
    if (organizations.length && !accounts.length) {
      const {users = [], name: tenantName} = (await dbAccessor.queryStore('tenants', organizations[0])).data()
      let tenantInfo = users.find(user => user.name === tenantName)
      userPayload = {
        accounts: [
          {
            email: tenantInfo.email,
            name: tenantInfo.name,
            key: organizations[0],
            role: 0,
            roles: tenantInfo.roles
          },
          {
            email: userExtra.email,
            name: userExtra.name,
            key: activeWarehouse,
            role: userExtra.role,
            roles: payload.roles
          }]
      }
    }
    if (warehouses.length || organizations.length) delete userPayload.warehouses
    let params = userPayload.accounts.reduce?.((acc, account) => {
      acc[account.key] = account.roles
      return acc
    }, {
      email: payload.email,
      roles: accounts[0]?.roles || payload.roles,
      [activeWarehouse]: payload.roles
    }) ||
      accounts.reduce((acc, account) => {
        acc[account.key] = account.roles
        return acc
      },
      {
        email: payload.email,
        roles: accounts[0]?.roles || payload.roles,
        [activeWarehouse]: payload.roles
      })
    return dbAccessor.runInBatch(batch => {
      batch.update(dbAccessor.buildStoreQuery(['warehouses', activeWarehouse]), {
        users: dbAccessor.fieldValue().arrayUnion({
          ...payload,
          name,
          key: userDoc.id
        })
      })
      batch.update(dbAccessor.buildStoreQuery(['users', userDoc.id]), userPayload)
    })
      .then(() => {
        return dbAccessor.callFunction('grantUserRole', params)
      })
  },
  async removeUserFromWarehouse  ({commit, getters, dispatch}, payload) {
    // is there security risk?
    const warehouseRef = dbAccessor.buildStoreQuery(['warehouses', getters.activeWarehouse])
    const predicates = [
      {
        field: `email`,
        compare: '==',
        value: payload.email
      }
    ]
    const userDocs = await dbAccessor.queryWithPredicatesStore(predicates, 'users')
    if (userDocs.size === 0) {
      throw Error('Email address not found.')
    }
    const userRef = userDocs.docs[0].ref
    let params = {}
    return dbAccessor.runInTransactionStore(async (transaction) => {
      return Promise.all([transaction.get(warehouseRef), transaction.get(userRef)])
        .then(([warehouseDoc, userDoc]) => {
          let { accounts = [] } = userDoc.data()
          let { users = [] } = warehouseDoc.data()
          let userAccounts = accounts.filter((account) => account.email !== getters.userExtra.email)
          let userPayload = {
            accounts: userAccounts,
            warehouses: []
          }
          params = userAccounts.reduce((acc, account) => {
            acc[account.key] = account.roles
            return acc
          }, {
            email: payload.email,
            roles: ['user']
          })
          if (accounts[0].email !== getters.userExtra.email) {
            delete userPayload.warehouses
            params.roles = accounts[0].roles
          }
          if (accounts[1] && accounts[0].email === getters.userExtra.email) {
            params.roles = accounts[1].roles
            if (accounts[1].role === 0) userPayload.organizations = [accounts[1].key]
            if (accounts[1].role === 2) userPayload.warehouses = [accounts[1].key]
          }

          transaction.update(warehouseRef, {
            users: users.filter(user => user.email !== payload.email)
          })
          !userPayload.accounts.length && (userPayload.warehouses = [])
          transaction.update(userRef, userPayload)
        })
    })
      .then(() => {
        return dbAccessor.callFunction('grantUserRole', params)
      })
  },
  async editUserForWarehouse  ({commit, getters, dispatch}, payload) {
    // is there security risk?
    const { userExtra, activeWarehouse } = getters
    const warehouseRef = dbAccessor.buildStoreQuery(['warehouses', activeWarehouse])
    let predicates = [{
      field: 'email',
      compare: '==',
      value: payload.email
    }]
    const userDocs = await dbAccessor.queryWithPredicatesStore(predicates, 'users')
    if (userDocs.size === 0) {
      throw Error('Email address not found.')
    }
    let params = {}
    return dbAccessor.runInTransactionStore(async (transaction) => {
      return Promise.all([transaction.get(warehouseRef), transaction.get(userDocs.docs[0].ref)])
        .then(([warehouseDoc, userSnapshot]) => {
          const userDoc = userDocs.docs[0]
          let { accounts = [] } = userDoc.data()
          let {users} = warehouseDoc.data()
          if (!accounts.length) {
            accounts = [{
              email: userExtra.email,
              name: userExtra.name,
              key: activeWarehouse,
              role: userExtra.role,
              roles: payload.roles
            }]
          }

          params = { email: payload.email }
          accounts.forEach(account => {
            if (account.email === getters.userExtra.email) account.roles = payload.roles
            params[account.key] = account.roles
          })
          params.roles = accounts[0].roles
          params[activeWarehouse] = payload.roles

          users.forEach(user => {
            if (user.email === payload.email) {
              user.roles = payload.roles
              user.sites = payload.sites
              user.note = payload.note || ''
            }
          })

          transaction.update(warehouseRef, {users})
          transaction.update(userSnapshot.ref, {accounts})
        })
    })
      .then(() => {
        return dbAccessor.callFunction('grantUserRole', params)
      })
  },
  addWarehouseAddress ({commit, getters}, payload) {
    return dbAccessor.insertStore(payload, 'warehouses', getters.activeWarehouse, 'sites')
      .then(() => {
        return dbAccessor.callFunction('syncWarehouseAddress', {warehouseKey: getters.activeWarehouse})
      })
      .then(() => {
        console.log('Sync success!')
      })
  },
  editWarehouseAddress ({commit, getters}, payload) {
    let key = payload.key
    delete payload.key
    return dbAccessor.updateStore(payload, 'warehouses', getters.activeWarehouse, 'sites', key)
      .then(() => {
        return dbAccessor.callFunction('syncWarehouseAddress', {warehouseKey: getters.activeWarehouse})
      })
      .then(() => {
        console.log('Sync success!')
      })
  },
  deleteWarehouseAddress ({commit, getters}, payload) {
    return dbAccessor.removeStore('warehouses', getters.activeWarehouse, 'sites', payload.key)
      .then(() => {
        return dbAccessor.callFunction('syncWarehouseAddress', {warehouseKey: getters.activeWarehouse})
      })
      .then(() => {
        console.log('Sync success!')
      })
  },
  getWarehouseLimitedInfo ({getters, commit}) {
    let successFunc = (doc) => {
      let limitedInfo
      if (!doc.exists) {
        limitedInfo = {
          warehouseName: getters.userExtra.name,
          orgSettings: {isAcceptNewOrg: true},
          isListed: false
        }
        dbAccessor.runInTransactionStore(async transaction => {
          let warehouseLimitedInfoDoc = await transaction.get(dbAccessor.buildStoreQuery(['warehouseLimitedInfo', getters.activeWarehouse]))
          if (!warehouseLimitedInfoDoc.exists) {
            console.log('warehouseLimitedInfo missing. initialize')
            transaction.set(warehouseLimitedInfoDoc.ref, limitedInfo)
          }
        })
      } else {
        limitedInfo = doc.data()
        limitedInfo.rates = limitedInfo.rates || {
          unitRates: [
            { sortKey: 0, name: 'small', packageInbound: 0, packageOutbound: 0, inbound: 0, outbound: 0, storage: 0 },
            { sortKey: 1, name: 'medium', packageInbound: 0, packageOutbound: 0, inbound: 0, outbound: 0, storage: 0 },
            { sortKey: 2, name: 'large', packageInbound: 0, packageOutbound: 0, inbound: 0, outbound: 0, storage: 0 }
          ]
        }
        const packings = limitedInfo.packings || []
        commit('setPackings', packings.map(pkg => {
          return {...pkg, warehouseKey: getters.activeWarehouse, id: pkg.name || ''}
        }))
      }
      commit('setWarehouseLimitedInfo', limitedInfo)
    }

    let errorFunc = (error) => {
      console.log(error)
      commit('setLoading', false)
      throw error
    }

    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['warehouseLimitedInfo', getters.activeWarehouse])
    commit('addTosubscribed', {warehouseLimitedInfo: unsubscribe})
  },
  loadSignupWarehouseRequests ({commit, getters}, payload) {
    if (getters.activeWarehouse) {
      let predicates = [{
        field: 'warehouseKey',
        compare: '==',
        value: getters.activeWarehouse
      }]
      return dbAccessor.queryWithPredicatesStore(predicates, 'joinWarehouseRequests')
        .then(docs => {
          let requests = []
          docs.forEach(doc => {
            requests.push({
              ...convertTimestampToDateInObj(doc.data()),
              key: doc.id,
              organizationId: ''
            })
          })
          return requests
        })
    }
  },
  loadSignupWarehouseRequestsForTenant ({commit, getters}, payload) {
    if (getters.activeOrganization) {
      let predicates = [{
        field: 'tenantKey',
        compare: '==',
        value: getters.activeOrganization
      }]
      return dbAccessor.queryWithPredicatesStore(predicates, 'joinWarehouseRequests')
        .then(docs => {
          let requests = []
          docs.forEach(doc => {
            requests.push({
              ...convertTimestampToDateInObj(doc.data()),
              key: doc.id,
              organizationId: ''
            })
          })
          return requests
        })
    }
  },
  async signupWarehouseWithName ({dispatch, getters}, payload) {
    let predicates = [{
      field: 'name',
      compare: '==',
      value: payload
    }]
    let docs = await dbAccessor.queryWithPredicatesStore(predicates, 'warehouses')
    if (docs.size !== 1) {
      throw Error('Warehouse does not exist.')
    }

    let data = docs.docs[0]
    let {users = []} = data.data()
    if (users.some(user => user.name === getters.tenant.name)) throw Error('User has already been accepted by this warehouse.')
    let request = {
      warehouseKey: data.id,
      warehouseName: payload,
      tenantKey: getters.activeOrganization,
      tenantName: getters.tenant.name,
      email: getters.user.email
    }
    return dispatch('signupWarehouse', request)
  },
  async signupWarehouseWithKey ({dispatch, getters}, payload) {
    let doc = await dbAccessor.queryStore('warehouses', payload.warehouseKey)
    if (!doc.exists) throw Error('Warehouse not found.')

    let {users = []} = doc.data()
    if (users.some(user => user.name === getters.tenant.name)) throw Error('User has already been accepted by this warehouse.')

    let request = {
      warehouseKey: doc.id,
      warehouseName: payload.warehouseName,
      tenantKey: getters.activeOrganization,
      tenantName: getters.tenant.name,
      email: getters.user.email
    }
    return dispatch('signupWarehouse', request)
  },
  signupWarehouse ({commit, getters}, payload) {
    let {warehouseKey, warehouseName} = payload
    let request = {
      warehouseKey,
      warehouseName,
      tenantKey: getters.activeOrganization,
      tenantName: getters.tenant.name,
      email: getters.user.email
    }
    let predicates = [{
      field: 'warehouseKey',
      compare: '==',
      value: warehouseKey
    },
    {
      field: 'tenantKey',
      compare: '==',
      value: getters.activeOrganization
    }]
    return dbAccessor.queryWithPredicatesStore(predicates, 'joinWarehouseRequests')
      .then(docs => {
        if (docs.size === 0) {
          return dbAccessor.insertStore(request, 'joinWarehouseRequests')
            .then(docRef => {
              return {...request, key: docRef.id}
            })
        }
      })
  },
  async getWarehouseInventory ({commit, getters}, payload) {
    let {isAll, siteKey} = payload
    const predicates = [{
      field: 'siteKey',
      compare: '==',
      value: siteKey
    }]
    let docsArray = isAll ?
      await dbAccessor.queryWithPredicatesStore(predicates, 'warehouses', getters.activeWarehouse, 'inventory') :
      await Promise.all(payload.tenantKeys.map(key => dbAccessor.queryStore('warehouses', getters.activeWarehouse, 'inventory', `${siteKey}_${key}`)))
    let products = {}
    docsArray.forEach(item => {
      if (item.exists) {
        let {abnormalDistribution = {}, distribution = {}, tenantKey} = item.data()
        const upcSet = new Set([...Object.keys(distribution), ...Object.keys(abnormalDistribution)])
        upcSet.forEach(upc => {
          let quantity = distribution[upc] || 0
          let abnormalQty = abnormalDistribution[upc] || 0
          let productName = getters.getUpcName(upc) || 'New product'
          if (products[upc]) {
            if (quantity) products[upc].quantity += quantity
            if (abnormalQty) products[upc].abnormalQty += abnormalQty

            if (products[upc]['distribution'] && products[upc]['distribution'][tenantKey]) {
              products[upc]['distribution'][tenantKey].quantity = (products[upc]['distribution'][tenantKey].quantity || 0) + quantity
              products[upc]['distribution'][tenantKey].abnormalQty = (products[upc]['distribution'][tenantKey].abnormalQty || 0) + quantity
            } else if (products[upc]['distribution'] && !products[upc]['distribution'][tenantKey]) {
              products[upc]['distribution'][tenantKey] = {quantity, abnormalQty}
            } else {
              products[upc]['distribution'] = {[tenantKey]: {quantity, abnormalQty}}
            }
          } else {
            products[upc] = {
              upc,
              quantity,
              abnormalQty,
              productName,
              distribution: {[tenantKey]: {quantity, abnormalQty}}
            }
          }
        })
      }
    })
    return Object.values(products)
  },
  async willChangeCauseNegativeInventory ({commit, getters}, payload) {
    let {newPackages, oldPackages} = payload
    let newPkgMap = {}
    let oldPkgMap = {}

    newPackages.forEach((newPkg, index) => {
      if (newPkg.organizationKey) {
        let newKey = newPkg.organizationKey + '_' + newPkg.upc
        if (!newPkgMap[newKey]) {
          newPkgMap[newKey] = newPkg.quantity
        } else {
          newPkgMap[newKey] += newPkg.quantity
        }
      }

      if (oldPackages[index].organizationKey) {
        let oldKey = oldPackages[index].organizationKey + '_' + oldPackages[index].upc
        if (!oldPkgMap[oldKey]) {
          oldPkgMap[oldKey] = oldPackages[index].quantity
        } else {
          oldPkgMap[oldKey] += oldPackages[index].quantity
        }
      }
    })

    Object.keys(oldPkgMap).forEach(key => {
      if (!newPkgMap[key]) {
        newPkgMap[key] = -oldPkgMap[key]
      } else {
        newPkgMap[key] -= oldPkgMap[key]
      }
    })

    let pkgMapDiff = newPkgMap
    let promises = Object.keys(pkgMapDiff).map(async key => {
      if (pkgMapDiff[key] < 0) {
        let [organizationKey, upc] = key.split('_')
        return dbAccessor.queryWithPredicatesStore([{field: 'upc', compare: '==', value: upc}], 'tenants', organizationKey, 'inventory')
      }
      return Promise.resolve(false)
    })

    let rtns = await Promise.all(promises)
    return Object.keys(pkgMapDiff).filter((key, index) => {
      if (pkgMapDiff[key] < 0) {
        let inventoryDocs = rtns[index]
        if (inventoryDocs.size > 0) {
          let {quantity} = inventoryDocs.docs[0].data()
          let inventoryQty = quantity
          return inventoryQty + pkgMapDiff[key] < 0
        }
      }
      return false
    })
  },
  updateBillingRates ({commit, getters, dispatch}, payload) {
    let beforeValue = {...getters.warehouseLimitedInfo.rates}
    return dbAccessor.updateFieldsStore({rates: payload, hasRates: true}, 'warehouseLimitedInfo', getters.activeWarehouse)
      .then(() => {
        Logger.changeLog({
          beforeValue,
          actionPayload: payload,
          actionName: 'updateBillingRates',
          categories: ['balance', 'userInfo'],
          keys: [getters.activeWarehouse]
        })
      })
  },
  updateBillingOtherRates ({commit, getters, dispatch}, payload) {
    let beforeValue = {...getters.warehouseLimitedInfo.otherRates}
    return dbAccessor.updateFieldsStore({otherRates: payload, hasRates: true}, 'warehouseLimitedInfo', getters.activeWarehouse)
      .then(() => {
        Logger.changeLog({
          beforeValue,
          actionPayload: payload,
          actionName: 'updateBillingOtherRates',
          categories: ['balance', 'userInfo'],
          keys: [getters.activeWarehouse]
        })
      })
  },
  async editTierDiscount ({commit, getters, dispatch}, payload) {
    let beforeValue
    let {isDelete, key, ...restPayload} = payload
    let tierDiscounts = {...getters.warehouseLimitedInfo.tierDiscounts}
    if (isDelete) {
      beforeValue = {...tierDiscounts[key]}
      delete tierDiscounts[key]
    } else {
      if (key) {
        beforeValue = {...tierDiscounts[key]}
        delete tierDiscounts[key]
      } else {
        beforeValue = {}
        key = await dbAccessor.getNewDocumentKey('warehouseLimitedInfo').id
      }
      if (tierDiscounts) {
        tierDiscounts[key] = restPayload
      } else {
        tierDiscounts = {[key]: restPayload}
      }
    }
    let predicates = [{
      field: 'discountKey',
      compare: '==',
      value: key
    }]
    let organizationDocs = await dbAccessor.queryWithPredicatesStore(predicates, 'warehouses', getters.activeWarehouse, 'organizations')
    return dbAccessor.runInBatch(batch => {
      batch.update(dbAccessor.buildStoreQuery(['warehouseLimitedInfo', getters.activeWarehouse]), dbAccessor.addUpdateDocTimestamp({tierDiscounts}))
      organizationDocs.forEach(doc => {
        if (!isDelete) {
          batch.update(doc.ref, dbAccessor.addUpdateDocTimestamp({discountRate: payload.discountRate}))
        } else {
          batch.update(doc.ref, dbAccessor.addUpdateDocTimestamp({discountRate: null, discountKey: null}))
        }
      })
    })
      .then(() => {
        Logger.changeLog({
          beforeValue,
          actionPayload: payload,
          actionName: 'editTierDiscount',
          categories: ['balance', 'userInfo'],
          keys: [getters.activeWarehouse]
        })
      })
  },
  getWarehouseTransactionsPagination ({commit, getters}, payload) {
    let {transactionType, startDate, endDate, limit, startAfter} = payload
    let predicates
    if (getters.activeOrganization) {
      predicates = [{
        field: 'tenantKey',
        compare: '==',
        value: getters.activeOrganization
      }]
    }
    if (getters.activeWarehouse) {
      predicates = [{
        field: 'warehouseKey',
        compare: '==',
        value: getters.activeWarehouse
      }]
    }

    if (transactionType) {
      predicates.push({
        field: 'transactionType',
        compare: '==',
        value: transactionType
      })
    }

    if (startDate) {
      predicates.push({
        field: `createTime`,
        compare: '>=',
        value: startDate
      })
    }

    if (endDate) {
      predicates.push({
        field: `createTime`,
        compare: '<=',
        value: endDate
      })
    }

    if (payload && payload.predicates && payload.predicates.actionPredicates) {
      predicates = [...predicates, ...payload.predicates.actionPredicates]
    }

    if (payload.predicates && payload.predicates.predicateSelect) {
      predicates.push({
        field: `transactionType`,
        compare: '==',
        value: payload.predicates.predicateSelect
      })
    }
    return dbAccessor.queryWithPagination(predicates, ['warehouseTransactions'], 'createTime', true, startAfter, limit)
  },
  getSystemTransactionsPagination ({commit, getters}, payload) {
    let {startDate, endDate, limit, startAfter} = payload
    let predicates = []

    if (startDate) {
      predicates.push({
        field: `createTime`,
        compare: '>=',
        value: startDate
      })
    }

    if (endDate) {
      predicates.push({
        field: `createTime`,
        compare: '<=',
        value: endDate
      })
    }

    if (payload.predicates && payload.predicates.predicateSelect) {
      if (payload.predicates.predicateSelect === 'fee') {
        predicates.push({
          field: `type`,
          compare: 'in',
          value: ['label', 'fee']
        })
      } else {
        predicates.push({
          field: `type`,
          compare: '==',
          value: payload.predicates.predicateSelect
        })
      }
    }

    if (payload.predicates && payload.predicates.predicateText) {
      predicates.push({
        field: 'keywords',
        compare: 'array-contains-any',
        value: [payload.predicates.predicateText.toUpperCase(), payload.predicates.predicateText.toLowerCase()]
      })
    }

    if (payload && payload.predicates && payload.predicates.actionPredicates) {
      predicates = [...predicates, ...payload.predicates.actionPredicates]
    }
    return dbAccessor.queryWithPagination(predicates, ['systemTransactions'], 'createTime', true, startAfter, limit)
  },
  async adjustWarehouseBalance ({commit, getters}, payload) {
    Logger.log('adjustWarehouseBalance', payload)
    let {note, amount, type, tenantKey, offlineDepositDocId, clientName, keywords = [], attachments = []} = payload
    const mainAccount = getters.operator
    const operator = mainAccount?.name || 'root admin'
    if (typeof amount !== 'number' || Number.isNaN(amount)) throw Error('amount-type-error')
    if (amount === 0) return Promise.resolve()
    let newBalance
    let transactionLog = {
      note,
      transactionType: type,
      tenantKey,
      warehouseKey: getters.activeWarehouse,
      workerKey: mainAccount.uid,
      workerName: mainAccount.name,
      operator,
      keywords,
      attachments
    }
    let rtn = await dbAccessor.callFunction('getServerTime', {})
    let currentTime = new Date(rtn.data)
    let curKeyStr = `${currentTime.getFullYear()}-${currentTime.getMonth() + 1}`

    if (type === 'adjust') {
      return dbAccessor.runInTransactionStore(async transaction => {
        let transactionLogRef = dbAccessor.getNewDocumentKey('warehouseTransactions')
        let billingDoc = await transaction.get(dbAccessor.buildStoreQuery(['warehouses', getters.activeWarehouse, 'billings', `${getters.activeWarehouse}_${tenantKey}`]))
        let offlineDepositDoc
        if (offlineDepositDocId) {
          offlineDepositDoc = await transaction.get(dbAccessor.buildStoreQuery(['depositRequests', offlineDepositDocId]))
        }
        let {balance = 0} = billingDoc.data() || {}
        newBalance = balance + amount
        if (billingDoc.exists) transaction.update(billingDoc.ref, dbAccessor.addUpdateDocTimestamp({balance: toMoney(newBalance), tenantKey}))
        else {
          transaction.set(billingDoc.ref, dbAccessor.addUpdateDocTimestamp({
            balance: toMoney(newBalance),
            tenantKey,
            expenseHistory: []
          }))
        }
        transactionLog.newBalance = toMoney(newBalance)
        transactionLog.amount = amount
        transactionLog.clientName = clientName
        if (offlineDepositDocId) {
          if (offlineDepositDoc?.exists) {
            transaction.update(offlineDepositDoc.ref, {
              isAdjustedBalance: true,
              transactionDocKeys: dbAccessor.fieldArrayUnion([transactionLogRef.id])
            })
          }
          transactionLog.offlineDepositDocId = offlineDepositDocId
          transactionLog.offlineType = payload.offlineType
        }
        transaction.set(transactionLogRef, dbAccessor.addNewDocTimestamp(transactionLog))
      })
    } else if (type === 'fee') {
      return dbAccessor.runInTransactionStore(async transaction => {
        let transactionLogRef = dbAccessor.getNewDocumentKey('warehouseTransactions')
        let billingDoc = await transaction.get(dbAccessor.buildStoreQuery(['warehouses', getters.activeWarehouse, 'billings', `${getters.activeWarehouse}_${tenantKey}`]))
        let {balance = 0, expenseHistory = []} = billingDoc.data() || {}
        let billingUpdate
        let balanceDiff = amount
        newBalance = addNumbers(balance, balanceDiff)
        if (expenseHistory) {
          let tailMonth = expenseHistory[expenseHistory.length - 1]
          if (tailMonth && curKeyStr === tailMonth.dateKeyStr) {
            tailMonth.expense = addNumbers(-balanceDiff, tailMonth.expense || 0)
          } else {
            expenseHistory.push({
              dateKeyStr: curKeyStr,
              expense: toMoney(-balanceDiff)
            })
          }

          if (expenseHistory.length > 36) {
            expenseHistory.shift()
          }
          billingUpdate = {balance: newBalance, tenantKey}
        } else {
          billingUpdate = {
            tenantKey,
            balance: newBalance,
            expenseHistory: []
          }
        }
        if (billingDoc.exists) transaction.update(billingDoc.ref, dbAccessor.addUpdateDocTimestamp(billingUpdate))
        else transaction.set(billingDoc.ref, dbAccessor.addNewDocTimestamp(billingUpdate))
        transactionLog.newBalance = newBalance
        transactionLog.amount = amount
        transaction.set(transactionLogRef, dbAccessor.addNewDocTimestamp({...transactionLog, subtype: 'other service'}))
      })
    }
  },
  loadSettingPromotions ({commit, getters}) {
    return dbAccessor.queryStore('warehouses', getters.activeWarehouse, 'promotions')
      .then((promotionDocs) => {
        if (promotionDocs.docs.length <= 0) {
          commit('setSettingPromotions', [])
          return
        }

        let promotions = promotionDocs.docs.map((promotionDoc) => {
          return { ...convertTimestampToDateInObj(promotionDoc.data()), key: promotionDoc.id }
        })
        commit('setSettingPromotions', [...promotions])
      })
  },
  insertSettingPromotion ({commit, getters, dispatch}, payload) {
    return dbAccessor.insertStore(payload, 'warehouses', getters.activeWarehouse, 'promotions')
      .then((res) => commit('setSettingPromotions', [...getters.settingPromotions, {key: res.id, ...payload}]))
  },
  updateSettingPromotion ({commit, getters, dispatch}, payload) {
    let { key } = payload
    if (!key) return

    let promotions = [...getters.settingPromotions]
    let findIndex = promotions.findIndex(promotion => promotion.key === key)

    /**
     * @todo do deep compare with payload & old promotion,
     *   if promotion has been changed, clear this read list and commit this promotion to db
     */
    delete payload.readList
    promotions[findIndex] = {...payload}
    delete payload.key
    return dbAccessor.updateStore(payload, 'warehouses', getters.activeWarehouse, 'promotions', key)
      .then(() => commit('setSettingPromotions', promotions))
  },
  deleteSettingPromotion ({commit, getters}, payload) {
    let { key } = payload
    if (!key) return
    let promotions = [...getters.settingPromotions].filter(promotion => promotion.key !== key)

    return dbAccessor.removeStore('warehouses', getters.activeWarehouse, 'promotions', key)
      .then(res => commit('setSettingPromotions', promotions))
  },
  getWarehouseAnnouncements ({commit, getters}) {
    const cbFunc = (data) => {
      commit('setWarehouseAnnouncements', data)
    }
    let unsubscribe = Announcement.getByWarehouseRT(cbFunc, getters.activeWarehouse)
    commit('addTosubscribed', {warehouseAnnouncements: unsubscribe})
  },
  addPackageReportWarehouse ({commit, getters}, payload) {
    let report = new PackageReportWarehouse(payload, getters.activeWarehouse)
    return report.insert()
  },
  deletePackageReportWarehouse ({commit, getters}, payload) {
    let report = new PackageReportWarehouse(payload, getters.activeWarehouse)
    return report.delete()
  },
  loadPackageReportsWarehouse ({commit, getters}) {
    const cbFunc = (data) => {
      commit('setPackageReports', data)
    }
    let unsubscribe = PackageReportWarehouse.getRT(cbFunc, getters.activeWarehouse, [])
    commit('addTosubscribed', {packageReports: unsubscribe})
  },
  async checkWarehouseDistribution ({dispatch}, {key}) {
    return dispatch('getWarehouseInventory', {siteKey: key, isAll: true})
      .then(products => !!products.length)
  },
  getChangeLogs ({commit, getters}, payload) {
    let {limit, startAfter, actionName = ''} = payload
    let predicates = [{
      field: `actionName`,
      compare: '==',
      value: actionName || 'updatePackagesInfo'
    }, {
      field: 'warehouseKey',
      compare: '==',
      value: getters.activeWarehouse
    }]

    if (payload.predicates && payload.predicates.predicateText) {
      predicates.push({
        field: 'keywords',
        compare: 'array-contains',
        value: payload.predicates.predicateText
      })
    }
    return dbAccessor.queryWithPagination(predicates, ['changeLogs'], 'createTime', true, startAfter, limit)
  },
  getAbnormalPackages ({dispatch, commit, getters}, payload) {
    const cbFunc = (packages) => {
      if (packages.length) {
        dispatch('addNotification', {
          key: 'newAbnormalPackages',
          displayName: 'abnormal packages',
          pathName: 'abnormal package',
          path: '/package?tab=abnormalPackages'
        })
      } else commit('removeNotification', {key: 'newAbnormalPackages'})
      commit('setAbnormalPackages', packages)
    }
    const historyCbFunc = (packages) => {
      commit('setHistoryAbnormalPackages', packages)
    }
    if (getters.activeOrganization) {
      let unsubscribe = Package.getAbnormalPkgsGroupRTByTenantKey(
        cbFunc, getters.activeOrganization, getters.uid
      )
      commit('addTosubscribed', {tenantAbnormalPackages: unsubscribe})

      let unsubscribeHistory = Package.getAbnormalPkgsGroupRTByTenantKey(
        historyCbFunc, getters.activeOrganization, getters.uid, 'history'
      )
      commit('addTosubscribed', {tenantHistoryAbnormalPackages: unsubscribeHistory})
    } else if (getters.activeWarehouse) {
      let unsubscribe = Package.getAbnormalPkgsRTByWarehouseKey(
        cbFunc, getters.activeWarehouse, getters.uid, ''
      )
      commit('addTosubscribed', {warehouseAbnormalPackages: unsubscribe})

      let unsubscribeHistory = Package.getAbnormalPkgsRTByWarehouseKey(
        historyCbFunc, getters.activeWarehouse, getters.uid, '', 'history'
      )
      commit('addTosubscribed', {warehouseHistoryAbnormalPackages: unsubscribeHistory})
    }
  },
  async resolveAbnormalPackage ({commit, getters}, payload) {
    if (!payload.key) throw Error('cannot-find-package')
    return dbAccessor.callFunction('updatePackagesInfo', {
      ...payload,
      userName: getters.userExtra.name,
      operatorName: getters.operator.name,
      warehouseKey: getters.activeWarehouse,
      type: 'resolveAbnormalPkgsInfo'
    })
      .then((result) => {
        return result
      })
  },
  getAdjustLogs ({commit, getters}, payload) {
    let {limit, startAfter} = payload
    let predicates = [{
      field: `actionName`,
      compare: '==',
      value: 'adjustInventory'
    }, {
      field: 'warehouseKey',
      compare: '==',
      value: getters.activeWarehouse
    }]

    if (payload.predicates && payload.predicates.predicateText) {
      predicates.push({
        field: 'keywords',
        compare: 'array-contains',
        value: payload.predicates.predicateText
      })
    }
    return dbAccessor.queryWithPagination(predicates, ['changeLogs'], 'createTime', true, startAfter, limit)
  },
  async adjustInventory ({commit, getters}, payload) {
    let {upc, quantity, note, from, to, warehouseSite} = payload
    let predicates = [{
      field: 'upc',
      compare: '==',
      value: upc
    }]
    let toInventoryDocs = await dbAccessor.queryWithPredicatesStore(predicates, 'tenants', to.key, 'inventory')
    let fromInventoryDocs = await dbAccessor.queryWithPredicatesStore(predicates, 'tenants', from.key, 'inventory')

    if (toInventoryDocs.size !== 1) {
      throw Error(`Organization(${to.organizationId}) has not defined this product.`)
    }

    if (fromInventoryDocs.size !== 1) {
      throw Error(`Organization(${from.organizationId}) has not defined this product.`)
    }
    const fromDoc = fromInventoryDocs.docs[0]
    const toDoc = toInventoryDocs.docs[0]

    const fromData = fromDoc.data()
    const toData = toDoc.data()

    const beforeSnapshot = {
      fromQty: fromData.distribution ? ((fromData.distribution[`warehouse${fromDoc.id}${warehouseSite.key}`] || {}).quantity || 0) : 0,
      toQty: toData.distribution ? ((toData.distribution[`warehouse${toDoc.id}${warehouseSite.key}`] || {}).quantity || 0) : 0
    }

    let oldPackages = [{
      upc,
      organizationKey: from.key,
      quantity,
      warehouseSite: warehouseSite.key,
      siteName: warehouseSite.siteName,
      isAddedToInventory: true
    }]

    let newPackages = [{
      upc,
      organizationKey: to.key,
      quantity,
      warehouseSite: warehouseSite.key,
      siteName: warehouseSite.siteName,
      isAddedToInventory: true
    }]

    let reversePreviousPromises = updateInventoryPromise(oldPackages, getters.activeWarehouse, getters.warehouseName, '', '', true)
    let updateNewPromises = updateInventoryPromise(newPackages, getters.activeWarehouse, getters.warehouseName)

    return Promise.all([reversePreviousPromises, updateNewPromises])
      .then(() => {
        Logger.changeLog({
          beforeSnapshot,
          beforeValue: [{...oldPackages[0], quantity: -quantity}],
          actionPayload: newPackages,
          actionName: 'adjustInventory',
          categories: ['inventory'],
          keys: [],
          keywords: [upc, quantity, from.key, to.key, warehouseSite.key],
          warehouseKey: getters.activeWarehouse,
          note
        })
      })
      .catch(error => {
        commit('setError', error)
        commit('setLoading', false)
        throw error
      })
  },
  /** @param {{
    *   key,
    *   change: {
    *     isChange: Boolean,
    *     _old:{quantity?, abnormalQty?, normalQty?, note?, organizationKey?},
    *     _cur:{quantity?, abnormalQty?, normalQty?, note?, organizationKey?}
    *   },
    *   logPayload: Object
    * }} payload
    */
  updateAbnormalPackage ({commit, getters}, payload) {
    const {change} = payload
    if (!change.isChange) return change
    return dbAccessor.callFunction('updatePackagesInfo', {
      ...payload,
      userName: getters.userExtra.name,
      operatorName: getters.operator.name,
      warehouseKey: getters.activeWarehouse,
      type: 'updateAbnormalPkgsInfo'
    })
      .then((result) => {
        // change log
        return payload
      })
  },
  /**
   * @param {{
   *  [Orgkey: String]: {
   *    [upc: String]: number,
   *    pkg: number,
   *    unit: number
   *  }
   * }} payload
   */
  updatePackageAdjustBalanceRecommendations ({getters}, payload) {
    const changes = payload.changes
    let recommendations = {}
    const discountMap = new Map()
    const pricingPlanMap = new Map()
    let {warehousePricingPlans = []} = getters
    getters.tenantsWithBillings.forEach(item => {
      let {key, waives, discountRate, upcPricingPlans = []} = item
      discountMap.set(key, {waives, discountRate})
      if (upcPricingPlans.length && changes[key]) {
        pricingPlanMap.set(key, upcPricingPlans.reduce((map, key) => {
          const curPlan = warehousePricingPlans.find(template => template.key === key)
          curPlan && curPlan.upcs.forEach(upc => {
            !map[upc.upc] && (map[upc.upc] = upc)
          })
          return map
        }, pricingPlanMap.get(key) || {}))
      }
    })
    let forecastPkgOrgKeys = getters.warehouseInfo?.featureInboundForecastPkg || []
    const rates = getters.warehouseLimitedInfo.rates || {}
    const otherRates = getters.warehouseLimitedInfo.otherRates || {}
    const defaultRates = Object.assign({}, rates, {otherRates})
    Object.keys(changes).map(orgKey => {
      let inPackageFee = 0
      const orgRates = getRatesConfig(getters.tenantsWithBillings, orgKey, defaultRates)
      const {packageRates = {}, unitRates = {}, forecastUnitRates = {}} = orgRates
      const isOrgRates = defaultRates !== orgRates
      const { packageInbound: forecastPkgInboundFee = 0, unitFee: forecastUnitFee = 0, unpackingMinimumFee = 0 } = forecastUnitRates
      const size2InRateMap = new Map([
        ...unitRates.map(item => [item.name, item.inbound]),
        ...unitRates.map(item => [item.sortKey, {inbound: item.inbound, packageInbound: item.packageInbound || 0}])
      ])
      const size2StorageRateMap = new Map([
        ...unitRates.map(item => [item.name, item.storage]),
        ...unitRates.map(item => [item.sortKey, item.storage])
      ])
      let storageFee = 0
      let inboundFee = 0
      let {discountRate = 0, waives = []} = discountMap.get(orgKey) || {}
      let waivesSet = new Set(waives)
      let isForecastedCheckPackage = !!changes[orgKey].isCheckPackage
      let upcPricingPlan = pricingPlanMap.get(orgKey)
      let {upcInTrackingMap = {}} = changes[orgKey]
      Object.keys(changes[orgKey]).forEach((upc) => {
        const isNeedPay = upc !== 'pkg' && upc !== 'unit' && getters.upcMap[upc] !== undefined
        if (isNeedPay && upcPricingPlan?.[upc]) {
          const { storageFee: storage = 0, inboundFee: inbound = 0, associatedDiscount = false } = upcPricingPlan[upc]
          inPackageFee = 0
          packageRates.inbound = 0
          const discount = 1 - (discountRate || 0) / 100
          if (!waivesSet.has('storage')) {
            const unit = associatedDiscount ? (storage) * discount : storage
            storageFee += unit * changes[orgKey][upc]
          }
          if (!waivesSet.has('inbound')) {
            const unit = associatedDiscount ? (inbound) * discount : inbound
            inboundFee += unit * changes[orgKey].unit[upc]
          }
        } else if (isNeedPay && getters.upcMap[upc].size !== 'custom') {
          const size = getters.upcMap[upc].size
          !waivesSet.has('storage') && (storageFee += size2StorageRateMap.get(size) * changes[orgKey][upc])
          inPackageFee = Math.max(size2InRateMap.get(size).packageInbound, inPackageFee)
          if (!waivesSet.has('inbound')) {
            !isForecastedCheckPackage && (inboundFee += size2InRateMap.get(size).inbound * changes[orgKey].unit[upc])
            isForecastedCheckPackage && (inboundFee += forecastUnitFee * changes[orgKey].unit[upc])
          }
        } else if (isNeedPay && getters.upcMap[upc].size === 'custom') {
          inPackageFee = 0
          packageRates.inbound = 0
          !waivesSet.has('storage') && (storageFee += (getters.upcMap[upc].storageFee || 0) * changes[orgKey][upc])
          if (!waivesSet.has('inbound')) {
            inboundFee += (getters.upcMap[upc].inboundFee || 0) * changes[orgKey].unit[upc]
          }
        }

        const tracking = upcInTrackingMap[upc]
        if (isNeedPay) {
          // clear duplicate package fee
          const isOldPkg = changes[orgKey].pkg < 0
          if ((isOldPkg && payload.trackingMap[tracking]?.[0]) || (!isOldPkg && payload.trackingMap[tracking]?.[1])) {
            inPackageFee = 0
            packageRates.inbound = 0
            changes[orgKey].pkg = 0
          }
          if (!payload.trackingMap[tracking]) payload.trackingMap[tracking] = []

          if (isOldPkg) {
            payload.trackingMap[tracking][0] = true
          } else payload.trackingMap[tracking][1] = true
        }
      })
      if (!waivesSet.has('inbound')) {
        if (!forecastPkgOrgKeys.includes(orgKey)) inboundFee += (inPackageFee || packageRates.inbound || 0) * changes[orgKey].pkg
        if (forecastPkgOrgKeys.includes(orgKey) && isForecastedCheckPackage) inboundFee = (inboundFee > unpackingMinimumFee ? inboundFee : unpackingMinimumFee) + forecastPkgInboundFee
        if (forecastPkgOrgKeys.includes(orgKey) && !isForecastedCheckPackage) inboundFee = forecastPkgInboundFee
      }
      isOrgRates && (discountRate = 0) // if org rates, reset discount rate
      recommendations[orgKey] = {
        storageFee: -toMoney(storageFee),
        inboundFee: -toMoney(inboundFee),
        waives,
        discountRate,
        total: -toMoney((storageFee + inboundFee) * (100 - discountRate) / 100)
      }
    })
    return Object.keys(recommendations).map(key => {
      return {organizationKey: key, organizationId: getters.organizationKeyToId.get(key), ...recommendations[key]}
    })
  },
  async getWarehouseStat ({commit, getters}, payload) {
    let predicates = [{
      field: 'warehouseKey',
      compare: '==',
      value: getters.activeWarehouse
    }]

    const statDocs = await dbAccessor.queryWithPredicatesStore(predicates, 'warehouses', getters.activeWarehouse, 'statistics')
    let statistics = {}
    statDocs.docs.forEach(doc => {
      statistics[doc.id] = doc.data()
    })
    commit('setStatistics', statistics)
  },
  /** @param {{key: string}} payload */
  removeOrgWarehouseRequest ({commit, getters}, payload) {
    if (payload && payload.key) return dbAccessor.removeStore('joinWarehouseRequests', payload.key)
  },
  /**
   * @param {{
   *  approved: {
   *    template: string,
   *    attachments: Array<{
   *      fullPath: string,
   *      name: string
   *    }>
   *  },
   *  rejected: {
   *    template: string,
   *  }
   * }} payload
   */
  setEmailTemplates ({commit, dispatch, getters}, payload) {
    return dbAccessor.updateFieldsStore({emailTemplates: payload},
      'warehouseLimitedInfo', getters.activeWarehouse
    )
  },
  /**
   *
   * @param {{
   *  subject: string,
   *  body: {template: string, variables: {[key: string]: string}, attachments: []},
   *  recievers: Array<string>
   * }} payload email object
   */
  async sendMail ({commit, getters}, payload) {
    const body = new EmailBodyBuilder(
      payload.body.template,
      payload.body.variables,
      payload.body.attachments || []).toEmail()
    return dbAccessor.callFunction('sendMail', {...payload, body})
  },
  /** save Warehouse's organization settings **/
  async saveOrgSettingsChange ({commit, dispatch, getters}, payload) {
    const {warehouseOrgSettings = {}} = getters
    let newSettings = {...warehouseOrgSettings, ...(payload || {})}
    return dbAccessor.updateFieldsStore(
      dbAccessor.addUpdateDocTimestamp({
        orgSettings: newSettings
      }),
      'warehouseLimitedInfo', getters.activeWarehouse
    )
  },
  async updateWarehouseLimitedInfo ({commit, getters}, payload) {
    const {warehouseKey, ...rest} = payload
    return dbAccessor.updateFieldsStore(dbAccessor.addUpdateDocTimestamp({
      ...rest
    }),
    'warehouseLimitedInfo', getters.activeWarehouse || warehouseKey)
      .then(() => {
        commit('setWarehouseListed', payload.isListed)
      })
  },
  // updateTempSku ({commit, getters}, payload) {
  //   const {sku, description, size, unitFee, organizationKey} = payload
  //   return dbAccessor.updateStore({
  //     sku,
  //     description,
  //     size,
  //     unitFee,
  //     organizationKey,
  //     isSku: true
  //   }, 'warehouses', getters.activeWarehouse, 'upcs', `${organizationKey}_${sku}`)
  // },
  // deleteTempSku ({commit, getters}, payload) {
  //   const {sku, organizationKey} = payload
  //   return dbAccessor.removeStore('warehouses', getters.activeWarehouse, 'upcs', `${organizationKey}_${sku}`)
  // },
  async acceptSkuRequest ({commit, getters}, payload) {
    await dbAccessor.callFunction('acceptSkuRequest', payload)
    if (!getters.skuRequests.length || !getters.skuRequests.filter(item => item.key !== payload.key).length) {
      commit('removeNotification', {key: 'newSkuRequests'})
    }
  },
  async removeApprovedSku ({commit, getters}, payload) {
    const { key, sku, tenantKey, upc, warehouseKey, keywordForSearch = '' } = payload
    const tenantInventoryDocs = await dbAccessor.queryWithPredicates(
      [{
        field: `upc`,
        compare: '==',
        value: upc
      }],
      ['tenants', tenantKey, 'inventory']
    )
    let oldPayload, newPayload
    return dbAccessor.runInTransactionStore(async transaction => {
      const warehouseUpcDoc = await transaction.get(dbAccessor.buildStoreQuery(['warehouses', warehouseKey, 'upcs', key]))
      const tenantInventoryDoc = await transaction.get(
        tenantInventoryDocs.docs[0].ref
      )
      const { approvedSkus: tenantApprovedSkus = [] } = tenantInventoryDoc.data()
      const { approvedSkus: warehouseApprovedSkus = [] } = warehouseUpcDoc.data()
      oldPayload = {tenantApprovedSkus, warehouseApprovedSkus}
      const newWarehouseApprovedSkus = warehouseApprovedSkus.filter(approvedSku => approvedSku !== `${tenantKey}_${sku}`)
      const newtenantApprovedSkus = tenantApprovedSkus.filter(approvedSku => approvedSku !== `${warehouseKey}_${sku}`)
      newPayload = {newWarehouseApprovedSkus, newtenantApprovedSkus}
      transaction.update(warehouseUpcDoc.ref, {approvedSkus: newWarehouseApprovedSkus})
      transaction.update(tenantInventoryDoc.ref, {approvedSkus: newtenantApprovedSkus})
    })
      .then(() => {
        const keywords = keywordForSearch && keywordForSearch.length ? keywordForSearch.split(', ') : []
        return Logger.changeLog({
          beforeValue: oldPayload,
          actionPayload: newPayload,
          actionName: 'removeLinkedSku',
          categories: ['upc'],
          keys: [warehouseKey, tenantKey],
          keywords: [...new Set([...keywords, key, sku, tenantKey, upc, warehouseKey])]
        })
      })
      .catch(error => {
        console.log(error)
        throw error
      })
  },
  getUnScannedItems ({commit, getters}, payload) {
    let predicates = []
    let sortName = 'createTime'
    if (payload && payload.predicates && payload.predicates.actionPredicates) {
      predicates = [...predicates, ...payload.predicates.actionPredicates]
      const [{ field }] = payload.predicates.actionPredicates
      if (field === 'trackings') sortName = ''
    }

    payload.startDate && payload.endDate && (predicates = [...predicates, {
      field: `createTime`,
      compare: '>=',
      value: payload.startDate
    },
    {
      field: `createTime`,
      compare: '<=',
      value: payload.endDate
    }])
    return dbAccessor.queryWithPagination(predicates, ['warehouses', getters.activeWarehouse, 'unScannedTrackings'], sortName, true, payload && payload.startAfter, payload && payload.limit)
  },
  getHistoryScannedItems ({commit, getters}, payload) {
    let predicates = []

    if (payload.predicates && payload.predicates.predicateText) {
      predicates.push({
        field: `trackings`,
        compare: 'array-contains',
        value: payload.predicates.predicateText.toUpperCase()
      })
    }

    if (payload && payload.predicates && payload.predicates.actionPredicates) {
      predicates = [...predicates, ...payload.predicates.actionPredicates]
    }

    payload.startDate && payload.endDate && (predicates = [...predicates, {
      field: `createTime`,
      compare: '>=',
      value: payload.startDate
    },
    {
      field: `createTime`,
      compare: '<=',
      value: payload.endDate
    }])
    return dbAccessor.queryWithPagination(predicates, ['warehouses', getters.activeWarehouse, 'scannedTrackings'], 'createTime', true, payload && payload.startAfter, payload && payload.limit)
  },
  async loadInboundConfig ({ commit, getters }) {
    const doc = await dbAccessor.queryStore('sysAdmin', 'inboundConfig')
    if (!doc.exists) return 'done'
    const updatePrescanHistory = doc.get('updatePrescanHistory')
    commit('setIsInboundConfig', updatePrescanHistory.includes(getters.activeWarehouse))
  },
  async uploadScannedTrackings ({commit, getters, state}, payload) {
    const inboundTrackingSet = new Set(getters.inboundTrackingCache)
    const {trackings, type, carrier, uploadedFiles, serviceType, note, siteKey} = payload
    const key = getRandomIdByTime(3)
    const operator = getters.operator
    await dbAccessor.updateStore({
      trackings,
      uploadedTrackings: trackings.filter(item => inboundTrackingSet.has(item)),
      carrier,
      type,
      serviceType,
      note,
      uploadedFiles,
      workerKey: operator.uid,
      workerName: operator.name,
      siteKey
    }, 'warehouses', getters.activeWarehouse, 'scannedTrackings', key)

    if (!state.isInboundConfig) return

    const unScanTrackings = trackings.filter(item => !inboundTrackingSet.has(item))
    if (!unScanTrackings.length) return

    const MAX_CACHE = 5000
    const path = ['warehouses', getters.activeWarehouse, 'uploadHistory', `prescanCache_${siteKey}`]
    const prescanCacheDoc = await dbAccessor.queryStore(...path)
    const prescanCacheDocData = prescanCacheDoc.get('prescanCache') || []
    // max 5000
    const overflowNum = prescanCacheDocData.length + unScanTrackings.length - MAX_CACHE
    // data splice
    if (overflowNum > 0) prescanCacheDocData.splice(0, overflowNum)
    const prescanCache = arrayToObj(prescanCacheDocData, 'tracking', 'prescanKey')
    // WARNING: Modify the original object data here, do not deep copy prescanCache
    unScanTrackings.forEach(tracking => {
      const prescanKeys = prescanCache[tracking]
      if (prescanKeys) prescanKeys.push(key)
      else prescanCacheDocData.push({ tracking, prescanKey: [key] })
    })
    const actionFunc = prescanCacheDoc.exists ? 'updateFieldsStore' : 'updateStore'
    return dbAccessor[actionFunc]({
      prescanCache: prescanCacheDocData
    }, ...path)
  },
  updatePrescanHistory ({commit, getters}, payload) {
    const {paginationKey, isInbound, ...rest} = payload
    return dbAccessor.updateFieldsStore({...rest, type: isInbound ? 'inbound' : 'outbound'}, 'warehouses', getters.activeWarehouse, 'scannedTrackings', paginationKey)
  },
  async createAudit ({commit, getters}, payload) {
    const {siteKey, note} = payload
    const _key = getRandomIdByTime(3)
    const inventoryDocs = await dbAccessor.queryWithPredicatesStore([{
      field: 'siteKey',
      compare: '==',
      value: siteKey
    }], 'warehouses', getters.activeWarehouse, 'inventory')
    const operator = getters.operator
    const auditRecord = new AuditRecord({
      inventoryDocs,
      siteKey,
      note,
      workerName: operator.name
    })
    const record = auditRecord.getData()
    await dbAccessor.updateStore(record, 'warehouses', getters.activeWarehouse, 'auditRecords', _key)
    return {
      ...record,
      _key
    }
  },
  async syncAuditInventory ({commit, getters}, payload) {
    let {siteKey, auditRecord} = payload
    const {upcs} = auditRecord
    const inventoryDocs = await dbAccessor.queryWithPredicatesStore([{
      field: 'siteKey',
      compare: '==',
      value: siteKey
    }], 'warehouses', getters.activeWarehouse, 'inventory')
    const operator = getters.operator
    const updatedRecord = new AuditRecord({
      inventoryDocs,
      siteKey,
      workerName: operator.name
    })
    const {upcs: updatedUpcs} = updatedRecord.getData()
    const updatedUpcMap = new Map(updatedUpcs.map(item => [item.upc, {qty: item.qty, abnormalQty: item.abnormalQty}]))
    const upcSet = new Set(upcs.map(item => item.upc))
    return {
      upcs: [
        ...(upcs.map(item => {
          const {qty = 0, abnormalQty = 0} = updatedUpcMap.get(item.upc) || {}
          return item.isConfirmed ? item : {...item, qty, abnormalQty}
        })),
        ...(updatedUpcs
          .filter(item => !upcSet.has(item.upc))
          .map(item => {
            const {qty, abnormalQty, upc} = item
            return {
              qty,
              abnormalQty,
              auditQty: 0,
              abnormalAuditQty: 0,
              isConfirmed: false,
              upc,
              note: ''
            }
          }))
      ]
    }
  },
  getAuditRecords ({commit, getters}, payload) {
    let predicates = []

    payload.startDate && payload.endDate && (predicates = [...predicates, {
      field: `createTime`,
      compare: '>=',
      value: payload.startDate
    },
    {
      field: `createTime`,
      compare: '<=',
      value: payload.endDate
    }])

    return dbAccessor.queryWithPagination(predicates, ['warehouses', getters.activeWarehouse, 'auditRecords'], 'createTime', true, payload && payload.startAfter, payload && payload.limit)
  },
  getOneAuditRecordRT ({commit, getters}, payload) {
    let {successFunc, errorFunc, key} = payload
    let unsubscribe = dbAccessor.queryRT(
      successFunc,
      errorFunc,
      [],
      ['warehouses', getters.activeWarehouse, 'auditRecords', key]
    )
    return unsubscribe
  },
  async saveAudit ({commit, getters}, payload) {
    const {_key, upcs, initUpcs, ...rest} = payload
    const auditDoc = await dbAccessor.queryStore('warehouses', getters.activeWarehouse, 'auditRecords', _key)
    const {upcs: updatedUpcs = []} = auditDoc.data() || {}
    const updatedUpcMap = new Map(updatedUpcs.map(item => [item.upc, item]))
    const initUpcMap = new Map(initUpcs.map(item => [item.upc, item]))
    let isUpcUpdated = false
    const newUpcs = upcs.map((item, index) => {
      const isThisItemUpdated = !deepEqual(initUpcMap.get(item.upc), updatedUpcMap.get(item.upc))
      // will turn true once an result is true
      isUpcUpdated = isUpcUpdated || isThisItemUpdated
      if (isThisItemUpdated && deepEqual(item, initUpcMap.get(item.upc))) {
        return updatedUpcMap.get(item.upc)
      } else {
        return {...item}
      }
    })
    if (isUpcUpdated) {
      if (confirm('This audit record has conflicts with recent updated version, Do you want to merge your update to the most recent version? If not will reverse your current changes.')) {
        await dbAccessor.updateFieldsStore({
          upcs: newUpcs,
          ...rest
        }, 'warehouses', getters.activeWarehouse, 'auditRecords', _key)
        return {status: 'done', newUpcs}
      }
      return {status: 'reverse'}
    }
    await dbAccessor.updateFieldsStore({
      upcs: newUpcs,
      ...rest
    }, 'warehouses', getters.activeWarehouse, 'auditRecords', _key)

    return {status: 'done', newUpcs}
  },
  async updateAudit ({commit, getters}, {_key, ...rest}) {
    await dbAccessor.updateFieldsStore({
      ...rest
    }, 'warehouses', getters.activeWarehouse, 'auditRecords', _key)

    return {status: 'done'}
  },
  getInboundTrackingCache ({commit, getters}) {
    const successFunc = (doc) => {
      const {trackings = []} = convertTimestampToDateInObj(doc.data() || {})
      commit('setInboundTrackingCache', trackings)
    }

    const errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }

    const unsubscribe = dbAccessor.queryRT(
      successFunc,
      errorFunc,
      [],
      ['warehouses', getters.activeWarehouse, 'uploadHistory', 'inboundTrackingCache']
    )
    commit('addTosubscribed', {uploadHistory: unsubscribe})
  },
  getDailyInboundRT ({commit, getters}, {siteKey, dateString}) {
    const successFunc = (doc) => {
      const { upcToQtyMapArray = [] } = convertTimestampToDateInObj(doc.data() || {})
      commit('setDailyInboundMap', new Map(upcToQtyMapArray.map(({key, value}) => [key, value])))
    }

    const errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }
    const unsubscribe = dbAccessor.queryRT(
      successFunc,
      errorFunc,
      [],
      ['warehouses', getters.activeWarehouse, 'sites', siteKey, 'dailyInbound', dateString]
    )
    commit('addTosubscribed', {dailyInbound: unsubscribe})
  },
  unsubscribeDailyInbound ({state}) {
    if (state.subscribed) {
      state.subscribed.dailyInbound && state.subscribed.dailyInbound()
      delete state.subscribed.dailyInbound
      state.dailyInbound = initialState.dailyInbound
    }
  },
  finishUpcStow ({commit, getters}, {stowMap, siteKey, dateKeyStr}) {
    return dbAccessor.runInTransactionStore(async transaction => {
      const doc = await transaction.get(dbAccessor.buildStoreQuery(['warehouses', getters.activeWarehouse, 'sites', siteKey, 'dailyInbound', dateKeyStr]))
      if (!doc.exists) throw Error('daily inbound doc missing')
      let {upcToQtyMapArray = []} = doc.data() || {}
      let upcToQtyMap = new Map(upcToQtyMapArray.map(({key, value}) => [key, value]))
      let stowList = []
      Object.keys(stowMap).forEach(upc => {
        if (upcToQtyMap.has(upc)) {
          let stowQty = stowMap[upc]
          let upcItem = upcToQtyMap.get(upc)
          upcItem.unstowedQty -= stowQty || 0
          if (upcItem.unstowedQty < 0) throw Error(`Upc: ${upc}, stow quantity exceeded real quantity.`)
          stowList.push({
            upc,
            stowQty,
            unstowedQty: upcItem.unstowedQty
          })
        }
      })
      upcToQtyMapArray = [...upcToQtyMap].map(([key, value]) => {
        return {key, value}
      })
      const operator = getters.operator
      let newLogRef = dbAccessor.buildStoreQuery(['stowHistory']).doc()
      let log = dbAccessor.addNewDocTimestamp({
        operator: operator.name,
        warehouseKey: getters.activeWarehouse,
        siteKey,
        dateKeyStr,
        keywords: [operator.name, dateKeyStr, ...Object.keys(stowMap)],
        stowList
      })
      transaction.set(
        newLogRef,
        log
      )
      transaction.update(doc.ref, dbAccessor.addUpdateDocTimestamp({
        upcToQtyMapArray
      }))
    })
  },
  getStowHistory ({commit, getters}, payload) {
    let predicates = [{
      field: 'warehouseKey',
      compare: '==',
      value: getters.activeWarehouse
    }]

    if (payload.predicates && payload.predicates.predicateText) {
      predicates.push({
        field: `keywords`,
        compare: 'array-contains',
        value: payload.predicates.predicateText.toLowerCase()
      })
    }

    payload.startDate && payload.endDate && (predicates = [...predicates, {
      field: `createTime`,
      compare: '>=',
      value: payload.startDate
    },
    {
      field: `createTime`,
      compare: '<=',
      value: payload.endDate
    }])
    return dbAccessor.queryWithPagination(predicates, ['stowHistory'], 'createTime', true)
  },
  getPickupRecordRT ({commit, getters}) {
    if (!getters.activeWarehouse) {
      return
    }

    let successFunc = (docs) => {
      let records = docs.docs.map(doc => {
        return {key: doc.id, ...convertTimestampToDateInObj(doc.data())}
      })
      commit('setPickupRecords', records)
    }

    let errorFunc = (error) => {
      console.error(`pickupRecords RT error`, error)
      throw error
    }

    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['warehouses', getters.activeWarehouse, 'pickupRecords'])
    commit('addTosubscribed', {pickupRecords: unsubscribe})
  },
  pickupItems ({commit, getters}, {selectedUpcs, selectedShipments, pickupType}) {
    if (!getters.activeWarehouse) {
      return
    }
    const siteKey = selectedShipments[0].products[0].warehouseSite
    const newShipments = getters.shipments
      .filter(shipment => shipment.products.some(product => product.warehouseSite === siteKey))

    const createPickupOrder = async (transaction, pickedUpcs) => {
      const pickupId = `PU${getRandomIdByTime(4).slice(1)}`
      const pickupOrderRef = dbAccessor.buildStoreQuery(['warehouses', getters.activeWarehouse, 'pickupOrders', pickupId])
      const shipmentDocs = await Promise.all(selectedShipments.map(shipment => transaction.get(dbAccessor.buildStoreQuery(['shipments', shipment._key]))))
      const pickupOrder = {
        pickupId,
        siteKey,
        status: 'pending',
        operatorId: getters.operator.uid,
        operatorName: getters.operator.name,
        shipments: selectedShipments.map(shipment => ({
          shipmentId: shipment._key,
          pickedUpcs: pickedUpcs[shipment._key] || []
        })),
        warehouseKey: getters.activeWarehouse
      }
      
      pickupOrder.keywords = [pickupId, getters.operator.name, ...pickupOrder.shipments.map(shipment => shipment.shipmentId)]
      transaction.set(pickupOrderRef, dbAccessor.addNewDocTimestamp(pickupOrder))
      shipmentDocs.forEach(shipmentDoc => {
        if (shipmentDoc.exists) {
          transaction.update(shipmentDoc.ref, dbAccessor.addUpdateDocTimestamp({pickupId}))
        }
      })
      return pickupOrder
    }

    if (pickupType === 'UPC') {
      const upcSet = new Set(selectedUpcs.map(item => item.upc))
      return dbAccessor.runInTransactionStore(async transaction => {
        const doc = await transaction.get(dbAccessor.buildStoreQuery(['warehouses', getters.activeWarehouse, 'pickupRecords', siteKey]))
        let {shipmentToPickedUpcs = {}} = doc.data() || {}
        let map = {}
        newShipments.forEach(({_key, products}) => {
          map[_key] = shipmentToPickedUpcs[_key] || []
          if (selectedShipments.some(({_key: shipmentKey}) => shipmentKey === _key)) {
            map[_key] = [...new Set([...map[_key], ...products.map(({upc}) => upc).filter(upc => upcSet.has(upc))])]
          }
        })
        
        const pickupOrder = await createPickupOrder(transaction, map)

        if (doc.exists) {
          transaction.update(doc.ref, dbAccessor.addUpdateDocTimestamp({shipmentToPickedUpcs: map}))
        } else {
          transaction.set(doc.ref, dbAccessor.addNewDocTimestamp({shipmentToPickedUpcs: map}))
        }
        return pickupOrder
      })
    }

    if (pickupType === 'shipment') {
      return dbAccessor.runInTransactionStore(async transaction => {
        const doc = await transaction.get(dbAccessor.buildStoreQuery(['warehouses', getters.activeWarehouse, 'pickupRecords', siteKey]))
        let {shipmentToPickedUpcs = {}} = doc.data() || {}
        let map = {}
        newShipments.forEach(({_key, products}) => {
          map[_key] = shipmentToPickedUpcs[_key] || []
          if (selectedShipments.some(({_key: shipmentKey}) => shipmentKey === _key)) {
            map[_key] = [...new Set([...map[_key], ...products.map(({upc}) => upc)])]
          }
        })

        const pickupOrder = await createPickupOrder(transaction, map)

        if (doc.exists) {
          transaction.update(doc.ref, dbAccessor.addUpdateDocTimestamp({shipmentToPickedUpcs: map}))
        } else {
          transaction.set(doc.ref, dbAccessor.addNewDocTimestamp({shipmentToPickedUpcs: map}))
        }
        return pickupOrder
      })
    }
  },
  cancelPickedItem ({ getters }, { cancelPickedItem, upc }) {
    if (!getters.activeWarehouse) return
    const siteKey = cancelPickedItem.products[0].warehouseSite
    const selectedAllShipments = getters.shipments
      .filter(shipment => shipment.products.some(product => product.warehouseSite === siteKey))
    return dbAccessor.runInTransactionStore(async transaction => {
      const pickupDoc = await transaction.get(dbAccessor.buildStoreQuery(['warehouses', getters.activeWarehouse, 'pickupRecords', siteKey]))
      if (!pickupDoc.exists) return
      let {shipmentToPickedUpcs = {}} = pickupDoc.data() || {}
      let updateShipmentToPickedUpcs = {}
      selectedAllShipments.forEach(({ _key }) => {
        const shipmentToPickedUpc = shipmentToPickedUpcs[_key]
        if (!shipmentToPickedUpc || !shipmentToPickedUpc.length) return
        if (cancelPickedItem._key === _key) {
          const filterUpcs = shipmentToPickedUpc.filter(pickedUpc => upc !== pickedUpc)
          if (filterUpcs.length) updateShipmentToPickedUpcs[_key] = filterUpcs
        } else {
          updateShipmentToPickedUpcs[_key] = shipmentToPickedUpc
        }
      })
      transaction.update(pickupDoc.ref, dbAccessor.addUpdateDocTimestamp({shipmentToPickedUpcs: updateShipmentToPickedUpcs}))
    })
  },
  async updateUnconfirmableFlag ({dispatch, commit, getters}, {pkgItemInfo, isUnconfirmable}) {
    const {key} = pkgItemInfo
    const result = await dbAccessor.queryStore('warehouses', getters.activeWarehouse, 'packages', key)
    let isConfirmed = result.get('isConfirmed')
    let payload = {uploadedPackages: [{...pkgItemInfo, isUnconfirmable}]}
    dbAccessor.callFunction('confirmTaskFromWarehouse', payload)
    if (isConfirmed) throw Error('confirmed-package')
    try {
      await result.ref.update({isUnconfirmable})
    } catch (error) {
      throw Error('general-update-failed')
    }
  },
  processImportOrder ({dispatch, commit, getters}, payload) {
    return dbAccessor.callFunction('processImportRequest', payload)
  },
  getImportService ({dispatch, commit, getters}, payload) {
    const { startDate, endDate, startAfter, limit = 25 } = payload
    const { predicateText, predicateSelect, actionPredicates } = payload && payload.predicates
    const {isAdmin} = getters.user
    const predicates = [
      {
        field: 'close',
        compare: '==',
        value: !!((actionPredicates && actionPredicates.length))
      }
    ]
    !isAdmin && predicates.push({
      field: 'userKey',
      compare: '==',
      value: getters.activeOrganization
    })
    predicateSelect && predicates.push({
      field: 'lastStatus',
      compare: '==',
      value: predicateSelect
    })
    predicateText && predicates.push({
      field: 'keywords',
      compare: 'array-contains',
      value: predicateText
    })
    startDate && predicates.push({
      field: `createTime`,
      compare: '>=',
      value: startDate
    })
    endDate && predicates.push({
      field: `createTime`,
      compare: '<=',
      value: endDate
    })
    return dbAccessor.queryWithPagination(predicates, ['importService'], 'createTime', true, startAfter, limit)
  },
  async getOverseaCustomers ({dispatch, commit, getters}, payload) {
    const predicates = [
      {
        field: 'betaFeatures',
        compare: 'array-contains',
        value: 'oversea'
      }
    ]
    try {
      const overseaCustomersDoc = await dbAccessor.queryWithPredicatesStore(predicates, 'tenantLimitedInfo')
      const arr = overseaCustomersDoc.docs.map(document => { return {displayName: document.data().name, userKey: document.id} })
      commit('setOverseaUsersList', arr)
    } catch (error) {
      console.log(error)
      throw error
    }
  },
  subscribeSingleImport ({getters}, payload) {
    const {cbFunc, billingNumber = ''} = payload
    if (typeof cbFunc !== 'function') throw Error('cbFunc-must-be-function')
    return dbAccessor.queryStoreRT(
      (doc) => (doc.exists && cbFunc(convertTimestampToDateInObj(doc.data()))) || {},
      (err) => { console.error(err) },
      [], 'importService', billingNumber
    )
  },
  async updateImportCloseStatus ({getters}, {billingNumber, close}) {
    return dbAccessor.runInBatch(batch => {
      billingNumber.forEach(billingNum => {
        batch.update(dbAccessor.buildStoreQuery(['importService', billingNum]), dbAccessor.addUpdateDocTimestamp({close}))
      })
    })

    // return dbAccessor.updateFieldsStore({close: !close}, 'importService', billingNumber)
  },
  async deleteImportOrders ({getters}, payload) {
    const {billingNumber, masterBillingNumber, associatedBillingList} = payload
    let masterAssociatedBillingList
    if (billingNumber !== masterBillingNumber) {
      const masterImportRef = await dbAccessor.queryStore('importService', masterBillingNumber)
      let {associatedBillingList} = masterImportRef.data()
      masterAssociatedBillingList = associatedBillingList.filter(billing => billing !== billingNumber)
    }
    await dbAccessor.runInBatch(batch => {
      batch.delete(dbAccessor.buildStoreQuery(['importService', billingNumber]))
      if (billingNumber === masterBillingNumber) {
        associatedBillingList.forEach(billingNum => {
          batch.delete(dbAccessor.buildStoreQuery(['importService', billingNum]))
        })
      } else {
        batch.update(dbAccessor.buildStoreQuery(['importService', masterBillingNumber]), {associatedBillingList: masterAssociatedBillingList})
      }
    })
      .then(async () => {
        // 将主单（masterBillingNumber）中子单列表中的本单号（billingNumber）删除
        return Logger.changeLog({
          beforeValue: payload,
          actionPayload: {},
          actionName: 'deleteImportOrder',
          categories: ['importService'],
          keys: [billingNumber],
          keywords: payload.keywords || [billingNumber.toLowerCase()]
        })
      })

    // if (billingNumber === masterBillingNumber) {
    //   // 是否需要将所有子单删除

    // } else {
    //   // 将主单（masterBillingNumber）中子单列表中的本单号（billingNumber）删除
    //   const masterImportRef = await dbAccessor.queryStore('importService', masterBillingNumber)
    //   let {associatedBillingList} = masterImportRef.data()
    //   associatedBillingList = associatedBillingList.filter(billing => billing !== billingNumber)
    //   promises.push(dbAccessor.updateFieldsStore({associatedBillingList}, 'importService', masterBillingNumber))
    // }
    // 删除本单
    // promises.push(
    //   dbAccessor.removeStore('importService', billingNumber)
    //     .then(() => {
    //       return Logger.changeLog({
    //         beforeValue: payload,
    //         actionPayload: {},
    //         actionName: 'deleteImportOrder',
    //         categories: ['importService'],
    //         keys: [billingNumber],
    //         keywords: payload.keywords || [billingNumber.toLowerCase()]
    //       })
    //     })
    //     .catch(error => {
    //       Logger.critical('deleteImportOrder', {error: error.message, ...payload})
    //     })
    // )
    // dbAccessor.runInBatch(batch => {

    // })
    // return Promise.all(promises)
  },

  searchForecastTracking ({commit, getters}, tracking) {
    let predicates = [{
      field: 'keywords',
      compare: 'array-contains',
      value: tracking
    }, {
      field: 'status',
      compare: 'in',
      value: ['ready', 'partial']
    }, {
      field: `warehouseKey`,
      compare: '==',
      value: getters.activeWarehouse
    }]
    return dbAccessor.queryWithPredicatesStore(predicates, 'forecasts')
      .then(docs => {
        if (docs.size === 0) {
          return false
        }

        return {...docs.docs[0].data(), key: docs.docs[0].id}
      })
      .catch(error => {
        throw error
      })
  },
  async getAdminOrWarehouseTransaction ({getters}, {docKey, item}) {
    if (item.vendorKey === 'system') return convertTimestampToDateInObj((await dbAccessor.queryStore('systemTransactions', docKey)).data())
    return convertTimestampToDateInObj((await dbAccessor.queryStore('warehouseTransactions', docKey)).data())
  },
  async getOfflineDeposit ({getters}, docKey) {
    return convertTimestampToDateInObj((await dbAccessor.queryStore('depositRequests', docKey)).data())
  },
  updateShipments ({getters}, payload) {
    const {docKey, isNeedUpdateFile = false, ...rest} = payload
    if (!isNeedUpdateFile) return dbAccessor.updateFieldsStore(rest, 'shipments', docKey)

    return dbAccessor.runInTransactionStore(async transaction => {
      let shipmentDoc = await transaction.get(dbAccessor.buildStoreQuery(['shipments', docKey]))
      if (!shipmentDoc.exists) throw Error('shipment doc missing')
      let {readyLabels = []} = shipmentDoc.data()
      rest.labels.forEach(item => {
        let index = readyLabels.findIndex(label => label.orderId === item.orderId)
        if (index !== -1) {
          item.url = readyLabels[index].url
          item.trackingNum = readyLabels[index].trackingNumber
          readyLabels.splice(index, 1)
        }
      })
      rest.readyLabels = readyLabels
      if (!rest.labels.length && !rest.files.length) {
        rest.zipFile = ''
        rest.zipfileDownloadURL = ''
      }
      transaction.update(shipmentDoc.ref, rest)
    })
      .then(() => {
        if (rest.labels.length || rest.files.length) {
          dbAccessor.callFunction('processShipmentLabelFiles', {...rest, key: docKey})
        }
        if (rest.files?.length) {
          let uploadMetadataPromises = rest.files.map(file => {
            file.task && delete file.task
            return dbAccessor.updateFileMetadata(file.fullPath, {...file, shipmentKey: docKey})
          })
          return Promise.all(uploadMetadataPromises)
        }
      })
  },
  loadUpcPricingPlan ({commit, getters}) {
    if (!getters.activeWarehouse) return

    let successFunc = (docs) => {
      if (!docs.size) return
      let pricingPlans = docs.docs.map(doc => {
        return {key: doc.id, ...convertTimestampToDateInObj(doc.data())}
      })
      commit('setWarehousePricingPlans', pricingPlans)
    }

    let errorFunc = (error) => {
      console.error(`warehousePricingPlans RT error`, error)
      throw error
    }

    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['warehouses', getters.activeWarehouse, 'pricingPlans'], 'createTime')
    commit('addTosubscribed', {warehousePricingPlans: unsubscribe})
  },
  addOrUpdateUpcPricingPlan ({getters}, payload) {
    let {key, ...rest} = payload
    return dbAccessor.updateStore(rest, 'warehouses', getters.activeWarehouse, 'pricingPlans', key || getRandomIdByTime(3))
  },
  deleteUpcPricingPlan ({getters}, {key}) {
    return dbAccessor.removeStore('warehouses', getters.activeWarehouse, 'pricingPlans', key)
  },
  editFinanceInfo ({ getters }, payload) {
    const { financeInfo, key, warehouseKey } = payload
    const { clientName, clientKey, cost, note } = financeInfo
    const updateFields = {}
    if (clientName) {
      updateFields['financeInfo.clientName'] = clientName
    }
    if (clientKey) {
      updateFields['financeInfo.clientKey'] = clientKey
    }
    if (!isNaN(cost) && cost >= 0 && cost !== undefined) {
      updateFields['financeInfo.cost'] = cost
    }
    if (note) {
      updateFields['financeInfo.note'] = note
    }
    return dbAccessor.updateFieldsStore({
      financeInfo
    }, 'warehouses', warehouseKey, 'packages', key)
  },
  searchProductRecords ({getters}, payload) {
    let { startDate, endDate, limit, startAfter, type, endBefore, isDesc = false } = payload
    let predicates = []

    if (startDate) {
      predicates.push({
        field: `createTime`,
        compare: '>=',
        value: startDate
      })
    }

    if (endDate) {
      predicates.push({
        field: `createTime`,
        compare: '<=',
        value: endDate
      })
    }

    if (payload.predicates && payload.predicates.actionPredicates && payload.predicates.actionPredicates.length) {
      let {actionPredicates} = payload.predicates
      if (actionPredicates.length > 1 || actionPredicates[0].value) predicates.push(...actionPredicates)
    }
    return dbAccessor.queryWithPagination(predicates, ['productRecords'], 'createTime', !isDesc, startAfter, limit, endBefore, type)
  },
  processSignature ({getters}, payload) {
    return dbAccessor.callFunction('processSignature', {...payload})
  },
  downloadProductRecords ({getters}, payload) {
    const {startDate, endDate} = payload
    let predicates = [
      {
        field: `createTime`,
        compare: '>=',
        value: startDate
      },
      {
        field: `createTime`,
        compare: '<=',
        value: endDate
      }
    ]
    return dbAccessor.queryWithPredicatesStore(predicates, 'productRecords')
      .then(docs => {
        let requests = []
        docs.forEach(doc => {
          requests.push({
            ...convertTimestampToDateInObj(doc.data())
          })
        })
        return requests
      })
  },
  async getOrgProductsInWarehouse ({commit, getters}, payload) {
    let docsArray = await Promise.all(payload.tenantKeys.map(key => dbAccessor.queryStore('warehouses', getters.activeWarehouse, 'organizations', key, 'products')))
    let products = []
    docsArray.forEach(docs => {
      docs.forEach(doc => {
        const data = convertTimestampToDateInObj({...doc.data(), _key: doc.id})
        products.push(data)
      })
    })
    return products
  },
  async getOrgProductsInWarehouseRT ({commit, getters, dispatch, state, rootState}, payload) {
    if (!getters.activeWarehouse) {
      return
    }
    const tenantKeys = getters.warehouseOrganizations.map(org => org.key)
    const successFunc = (docs) => {
      let products = docs.docs.map(doc => {
        return convertTimestampToDateInObj({...doc.data(), _key: doc.id})
      })
      const oldWarehouseProducts = getters.warehouseProducts || []
      const filteredWarehouseProducts = oldWarehouseProducts.filter(product => {
        return tenantKeys.includes(product.organizationKey)
      })
      const newWarehouseProducts = [...filteredWarehouseProducts, ...products]
      if (newWarehouseProducts.length) {
        commit('setWarehouseProducts', newWarehouseProducts)
      }
    }
    const errorFunc = error => {
      console.log(error)
    }
    Promise.all(tenantKeys.map(key => {
      const unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['warehouses', getters.activeWarehouse, 'organizations', key, 'products'])
      commit('addTosubscribed', {[`warehousesProducts_${key}`]: unsubscribe})
    }))
  }, 
  async getOrgProductByUpc ({commit, getters}, payload) {
    const {upc, organizationKey} = payload
    const doc = await dbAccessor.queryStore('warehouses', getters.activeWarehouse, 'organizations', organizationKey, 'products', upc)
    if (!doc.exists) return null
    const data = convertTimestampToDateInObj({...doc.data(), _key: doc.id})
    return data
  },
  async editProductInOrg ({getters, commit}, payload) {
    const {path, weight, length, width, height, _key, organizationKey, note = '', shippingRanges = [], quantityLimit = 0} = payload
    const updateFields = {weight, length, width, height, note, shippingRanges, quantityLimit}
    return dbAccessor.runInTransactionStore(async transaction => {
      let orgInventoryDoc = await transaction.get(dbAccessor.doc(path))
      if (!orgInventoryDoc.exists) throw Error('doc-missing')
      const currentProductDoc = await transaction.get(dbAccessor.buildStoreQuery(['warehouses', getters.activeWarehouse, 'organizations', organizationKey, 'products', _key]))
      if (!currentProductDoc.exists) throw Error('product-missing')
      transaction.update(currentProductDoc.ref, dbAccessor.addUpdateDocTimestamp(updateFields))
      delete updateFields.note
      delete updateFields.lastModifiedTime
      transaction.update(orgInventoryDoc.ref, Object.assign(updateFields, { warehouseLastUpdateTime: dbAccessor.getServerTimestamp() }))
      const upcMap = getters.upcMap
      const upc = payload.upc
      const upcItem = upcMap[upc]
      if (upcItem) {
        upcMap[upc] = {
          ...upcItem,
          ...updateFields
        }
      }
      commit('setUpcMap', upcMap)
      return {
        note,
        ...updateFields,
        _key
      }
    })
  },
  async batchEditShippingRanges ({getters, commit}, {products}) {
    return dbAccessor.runInTransactionStore(async transaction => {
      const docsToUpdate = await Promise.all(
        products.map(async product => {
          const {path, _key, organizationKey, shippingRanges} = product
          
          const orgInventoryDoc = await transaction.get(dbAccessor.doc(path))
          if (!orgInventoryDoc.exists) throw Error('doc-missing')

          const currentProductDoc = await transaction.get(
            dbAccessor.buildStoreQuery([
              'warehouses',
              getters.activeWarehouse,
              'organizations',
              organizationKey,
              'products',
              _key
            ])
          )
          if (!currentProductDoc.exists) throw Error('product-missing')

          return {
            product,
            orgInventoryDoc,
            currentProductDoc,
            updateFields: { shippingRanges }
          }
        })
      )

      const upcMap = getters.upcMap
      const results = docsToUpdate.map(({product, orgInventoryDoc, currentProductDoc, updateFields}) => {
        transaction.update(
          currentProductDoc.ref,
          dbAccessor.addUpdateDocTimestamp(updateFields)
        )

        transaction.update(orgInventoryDoc.ref, {
          ...updateFields,
          warehouseLastUpdateTime: dbAccessor.getServerTimestamp()
        })

        const upc = product.upc
        const upcItem = upcMap[upc]
        if (upcItem) {
          upcMap[upc] = {
            ...upcItem,
            ...updateFields
          }
        }

        return {
          ...updateFields,
          _key: product._key
        }
      })

      commit('setUpcMap', upcMap)
      return results
    })
  },
  async getLabelTemplateByOrg ({commit, getters}, payload) {
    const {organizationKey, sku} = payload
    const templates = await dbAccessor.queryStore('tenants', organizationKey, 'templates')
    const templateDocs = templates.docs.map(doc => ({...doc.data(), _key: doc.id}))
    if (!templateDocs.length) return null
    const packageDoc = await dbAccessor.queryStore('tenants', organizationKey, 'config', 'packagings')
    const {packagings = []} = packageDoc.data() || {}
    const matchTemplate = templateDocs.find((templateData) => {
      const skus = templateData.sku.toUpperCase().split(',')
      return sku.some((s) => skus.includes(s.toUpperCase()))
    })
    const defaultTemplate = [{
      id: 'Default packaging',
      name: 'Default(8"x8"x8")',
      length: 8,
      width: 8,
      height: 8,
      isPackagingDefault: true
    },
    {
      id: 'vite 20x14x4',
      name: 'vite(20"x14"x4")',
      length: 20,
      width: 14,
      height: 4,
      isPackagingDefault: true
    },
    {
      id: 'vite 20x18x16',
      name: 'vite(20"x18"x16")',
      length: 20,
      width: 18,
      height: 16,
      isPackagingDefault: true
    }]
    if (!matchTemplate) return null
    const { weightLb } = matchTemplate
    const pkg = packagings.find((p) => p.name === matchTemplate.packaging)
    const size = {}
    if (pkg) {
      const { length, width, height, isMeasurementMetric } = pkg
      const unit = isMeasurementMetric ? 'metric' : 'imperial'
      size.weight = weightLb
      size.length = length
      size.width = width
      size.height = height
      size.unit = unit
    } else {
      const matchDefault = defaultTemplate.find((p) => p.id === matchTemplate.packaging)
      if (matchDefault) {
        size.weight = weightLb
        size.length = matchDefault.length
        size.width = matchDefault.width
        size.height = matchDefault.height
        size.unit = 'imperial'
      } else {
        const pkgs = getters.packings
        const matchPkg = pkgs.find((p) => p.id === matchTemplate.packaging)
        if (matchPkg) {
          delete matchPkg.unit
          const unit = matchPkg.isMeasurementMetric ? 'metric' : 'imperial'
          size.weight = weightLb
          size.length = matchPkg.length
          size.width = matchPkg.width
          size.height = matchPkg.height
          size.unit = unit
        }
      }
    }
    return {
      ...matchTemplate,
      ...size,
      organizationKey,
      key: matchTemplate._key
    }
  },
  async createScanFormShipment ({ commit, getters }, payload) {
    const { referenceNo, orgKeys } = payload
    const warehouseKey = getters.activeWarehouse
    return dbAccessor.callFunction('scanFormShipments', {
      type: 'create',
      warehouseKey,
      referenceNo,
      orgKeys
    })
  },
  async clearExpiredScanForm ({ commit, getters }) {
    const warehouseKey = getters.activeWarehouse
    return dbAccessor.callFunction('scanFormShipments', {
      type: 'clear',
      warehouseKey
    })
  },
  async confirmScanFormShipment ({ commit, getters }, payload) {
    const { requestId, _id } = payload 
    const warehouseKey = getters.activeWarehouse
    dbAccessor.updateFieldsStore({
      [`shipments.${requestId}.isConfirm`]: true
    }, 'warehouses', warehouseKey, 'waitingScanFormShipments', _id)
  },
  getWaitingScanFormShipments ({commit, getters}) {
    const warehouseKey = getters.activeWarehouse
    let successFunc = (docs) => {
      let res = {}
      docs.forEach(doc => {
        const shipments = doc.get('shipments') || {}
        Object.values(shipments).forEach(shipment => {
          shipment._id = doc.id
        })
        Object.assign(res, shipments)
      })

      commit('setWaitingScanFormShipments', Object.values(res))
    }

    let errorFunc = (error) => {
      console.log(error)
      commit('setLoading', false)
      throw error
    }

    let predicates = []

    let unsubscribe = dbAccessor.queryStoreRT(successFunc, errorFunc, predicates, 'warehouses', warehouseKey, 'waitingScanFormShipments')
    commit('addTosubscribed', {waitingScanFormShipments: unsubscribe})
  },
  async getScanFormShipments ({ commit, getters }, payload) {
    let { limit, startAfter } = payload
    let predicates
    const warehouseKey = getters.activeWarehouse
    return dbAccessor.queryWithPagination(predicates, ['warehouses', warehouseKey, 'scanFormShipments'], 'createTime', true, startAfter, limit)
  },
  async getScanFormShipment ({ commit, getters }, payload) {
    const warehouseKey = getters.activeWarehouse
    return dbAccessor.callFunction('scanFormShipments', {
      type: 'get',
      warehouseKey,
      requestId: payload.requestId
    })
  },
  async deleteScanFormShipment ({ commit, getters }, payload) {
    const { _key } = payload
    const warehouseKey = getters.activeWarehouse
    return dbAccessor.removeStore('warehouses', warehouseKey, 'scanFormShipments', _key)
  },
  async updatePackagesOfWarehouseLimitedInfo ({getters}, payload) {
    const {packings = []} = payload
    return dbAccessor.updateFieldsStore({packings}, 'warehouseLimitedInfo', getters.activeWarehouse)
  },
  updateOrganizationRates ({ getters }, payload) {
    const {organizationKey, rates} = payload
    return dbAccessor.updateFieldsStore({rates}, 'warehouses', getters.activeWarehouse, 'organizations', organizationKey)
      .catch(error => {
        console.error('Failed to update organization rates:', error)
        throw error
      })
  },
  uploadDClassProducts ({commit, getters}, payload) {
    const {products, siteKey, siteName, organizationKey} = payload
    return dbAccessor.runInTransactionStore(async transaction => {
      const warehouseKey = getters.activeWarehouse
      const orgQuery = dbAccessor.buildStoreQuery(['tenants', organizationKey])
      const warehouseInventoryDoc = await transaction.get(dbAccessor.buildStoreQuery(['warehouses', warehouseKey, 'inventory', `${siteKey}_${organizationKey}`]))
      
      const orgDoc = await transaction.get(orgQuery)
      const orgData = orgDoc.data()
      let productIndex = orgData.productIndex || 0

      const productDocsForWarehouse = await Promise.all(products.map(product => 
        transaction.get(dbAccessor.buildStoreQuery(['warehouses', warehouseKey, 'organizations', organizationKey, 'products', product.upc]))
      ))

      const noExistProducts = []
      const tenantInventoryDocs = await Promise.all(products.map(async (item) => {
        const sn = await dbAccessor.queryWithPredicatesStore([{field: 'upc', compare: '==', value: item.upc}], 'tenants', organizationKey, 'inventory')
        if (!sn.size) {
          noExistProducts.push(item)
          return null
        }
        return sn.docs[0]
      })).then(results => results.filter(Boolean))
      const stockAgeDocs = await Promise.all(noExistProducts.map(async (item) => {
        return transaction.get(dbAccessor.buildStoreQuery(['warehouses', warehouseKey, 'organizations', organizationKey, 'upcs', item.upc]))
      }))
      const map = {}
      for (const product of noExistProducts) {
        const stockAgeDoc = stockAgeDocs.find(doc => doc.id === product.upc)
        productIndex += 1
        const id = productIndex.toString().padStart(8, '0')
        const distributionKey = `warehouse${id}${Buffer.from(siteKey).toString('base64')}`
        const newProduct = {
          ...product,
          distribution: {
            [distributionKey]: {
              quantity: product.quantity,
              uid: warehouseKey,
              userName: getters.warehouseName,
              warehouseSite: siteKey,
              siteName: siteName,
              warehouseKey
            }
          },
          isArchived: false,
          id: id,
          inbound: product.quantity,
          isDClassProduct: true,
          condition: 'new',
          price: 0,
          asin: []
        }
        map[product.upc] = newProduct

        if (!stockAgeDoc.exists) {
          transaction.set(stockAgeDoc.ref, dbAccessor.addNewDocTimestamp({
            upc: product.upc,
            [siteKey]: {
              [new Date().toISOString().slice(0, 10)]: product.quantity
            },
            organizationKey
          }))
        }
        transaction.set(dbAccessor.buildStoreQuery(['tenants', organizationKey, 'inventory', id]), dbAccessor.addNewDocTimestamp(newProduct))
      }
      
      if (warehouseInventoryDoc.exists) {
        const {distribution = {}} = warehouseInventoryDoc.data()
        const newDistribution = Object.keys(map).reduce((acc, upc) => {
          const qty = map[upc].quantity
          if (acc[upc]) {
            acc[upc] += qty
          } else {
            acc[upc] = qty
          }
          return acc
        }, distribution)
        transaction.update(warehouseInventoryDoc.ref, dbAccessor.addUpdateDocTimestamp({distribution: newDistribution}))
      } else {
        const distribution = Object.keys(map).reduce((acc, upc) => {
          acc[upc] = map[upc].quantity
          return acc
        }, {})
        const data = {
          abnormalDistribution: {},
          distribution: distribution,
          siteKey,
          tenantKey: organizationKey
        }
        transaction.set(warehouseInventoryDoc.ref, dbAccessor.addNewDocTimestamp(data))
      }

      tenantInventoryDocs.forEach(doc => {
        const {upc} = doc.data()
        const product = products.find(prod => prod.upc === upc)
        if (product) {
          const {quantity, ...updateFields} = product
          updateFields.warehouseLastUpdateTime = dbAccessor.getServerTimestamp()
          transaction.update(doc.ref, dbAccessor.addUpdateDocTimestamp(updateFields))
        }
      })

      productDocsForWarehouse.forEach(doc => {
        const product = products.find(prod => prod.upc === doc.id)
        if (doc.exists) {
          const {quantity, ...updateFields} = product
          transaction.update(doc.ref, dbAccessor.addUpdateDocTimestamp(updateFields))
        } else {
          const docData = map[doc.id]
          transaction.set(doc.ref, dbAccessor.addNewDocTimestamp({
            ...docData,
            warehouseKey,
            organizationKey,
            path: `tenants/${organizationKey}/inventory/${docData.id}`
          }))
        }
      })

      transaction.update(orgDoc.ref, dbAccessor.addUpdateDocTimestamp({productIndex}))
    })
  },
  async getPickupOrders ({commit, getters}, payload) {
    if (!getters.activeWarehouse) return
    const { startDate, endDate, limit, startAfter = null } = payload
    const predicates = [{
      field: 'status',
      compare: '==',
      value: 'pending'
    }]
    if (startDate) {
      predicates.push({
        field: 'createTime',
        compare: '>=',
        value: startDate
      })
    }

    if (endDate) {
      predicates.push({
        field: 'createTime',
        compare: '<=',
        value: endDate
      })
    }

    predicates.push({
      field: 'warehouseKey',
      compare: '==',
      value: getters.activeWarehouse
    })
    
    if (payload.predicates && payload.predicates.actionPredicates && payload.predicates.actionPredicates.length) {
      let {actionPredicates} = payload.predicates
      if (actionPredicates[0].value) predicates.push(...actionPredicates)
    }
    return dbAccessor.queryWithPagination(
      predicates,
      ['warehouses', getters.activeWarehouse, 'pickupOrders'],
      'createTime',
      true,
      startAfter,
      limit
    )
  },
  async deletePickupOrder ({commit, getters}, payload) {
    const {_key, siteKey} = payload
    const warehouseKey = getters.activeWarehouse
    const confirmShipmentTask = await dbAccessor.queryWithPredicatesStore([{field: 'processStatus', compare: '==', value: 'pending'}, {field: 'pickupId', compare: '==', value: _key}], 'warehouses', warehouseKey, 'confirmShipmentTask')
    if (confirmShipmentTask.size) {
      throw new Error('confirmShipmentTaskPending')
    }
    return dbAccessor.runInTransactionStore(async transaction => {
      const pickupOrderDoc = await transaction.get(dbAccessor.buildStoreQuery(['warehouses', warehouseKey, 'pickupOrders', _key]))
      if (!pickupOrderDoc.exists) return
      const doc = await transaction.get(dbAccessor.buildStoreQuery(['warehouses', getters.activeWarehouse, 'pickupRecords', siteKey]))
      const shipmentDocs = await Promise.all(payload.shipments.map(shipment => transaction.get(dbAccessor.buildStoreQuery(['shipments', shipment.shipmentId]))))
      shipmentDocs.forEach(shipmentDoc => {
        if (shipmentDoc.exists) {
          transaction.update(shipmentDoc.ref, dbAccessor.addUpdateDocTimestamp({pickupId: null}))
        }
      })
      if (doc.exists) {
        let {shipmentToPickedUpcs = {}} = doc.data() || {}
        const {shipments = []} = pickupOrderDoc.data() || {}
        shipments.forEach(shipment => {
          delete shipmentToPickedUpcs[shipment.shipmentId]
        }) 
        transaction.update(doc.ref, dbAccessor.addUpdateDocTimestamp({shipmentToPickedUpcs}))
      }
      transaction.delete(pickupOrderDoc.ref)
    })
  },
  async submitPickup ({commit, getters}, payload) {
    const {_key} = payload
    const warehouseKey = getters.activeWarehouse
    return dbAccessor.updateFieldsStore({status: 'done'}, 'warehouses', warehouseKey, 'pickupOrders', _key)
  },
  async batchUpdatePickupShipments ({ getters }, { pickupId, shipmentKeys, update }) {
    const warehouseKey = getters.activeWarehouse
    
    try {
      return dbAccessor.runInTransactionStore(async transaction => {
        const pickupDoc = await transaction.get(
          dbAccessor.buildStoreQuery(['warehouses', warehouseKey, 'pickupOrders', pickupId])
        )
  
        if (!pickupDoc.exists) {
          throw new Error('Pickup order not found')
        }
  
        const { shipments = [] } = pickupDoc.data()
  
        const updatedShipments = shipments.map(shipment => {
          if (shipmentKeys.includes(shipment.shipmentId)) {
            return {
              ...shipment,
              ...update
            }
          }
          return shipment
        })
  
        transaction.update(pickupDoc.ref, dbAccessor.addUpdateDocTimestamp({
          shipments: updatedShipments
        }))
      })
    } catch (error) {
      console.error('Failed to batch update pickup shipments:', error)
      throw error
    }
  },
  async batchConfirmShipments ({ getters }, { pickupId, shipments }) {
    try {
      let userType = 'warehouse'
      const operator = getters.operator
      const workerKey = operator.uid
      const workerName = operator.name
      const result = await dbAccessor.callFunction('batchShipment', {
        pickupId,
        shipments: shipments.map(s => {
          return {
            ...s,
            workerKey,
            workerName,
            userType,
            draftComments: s.draftComments.map(comment => ({
              ...comment,
              createTime: comment.createTime.toISOString ? comment.createTime.toISOString() : comment.createTime
            })),
            createTime: s.createTime.toISOString ? s.createTime.toISOString() : s.createTime
          }
        }),
        warehouseKey: getters.activeWarehouse,
        type: 'batchConfirmShipments'
      })
      return result.data
    } catch (error) {
      console.error('Failed to create batch confirm task:', error)
      throw error
    }
  },
  async saveThirdPartyResources ({commit, getters}, payload) {
    const {files, note, businessType, source} = payload
    return dbAccessor.callFunction('processThirdPartyResources', {
      files, note, businessType, source, actionType: 'save'
    })
  },
  async getThirdPartyResources ({commit, getters}, payload) {
    let successFunc = (docs) => {
      let resources = docs.docs.map(doc => {
        let resource = convertTimestampToDateInObj(doc.data())
        let key = doc.id
        return {key, ...resource}
      })
      commit('setThirdPartyResources', resources)
    }

    let errorFunc = (error) => {
      console.log(error)
      commit('setLoading', false)
      throw error
    }

    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['thirdPartyResources'])
    commit('addTosubscribed', {thirdPartyResources: unsubscribe})
  },
  async getEfficiencyStatistics ({commit, getters}, payload) {
    return dbAccessor.callFunction('processThirdPartyResources', {
      warehouseKey: getters.activeWarehouse,
      actionType: 'query',
      type: payload.type,
      sourceType: payload.sourceType,
      startDate: payload.startDate,
      endDate: payload.endDate
    })
  }
}

export const getters = {
  warehouseName (state) {
    return state.warehouseLimitedInfo.warehouseName
  },
  waitingScanFormShipments (state) {
    return state.waitingScanFormShipments
  },
  settingPromotions (state) {
    return state.settingPromotions
  },
  warehouseOrganizations (state) {
    return state.warehouseOrganizations
  },
  organizationKeyToId (state) {
    return new Map(state.warehouseOrganizations.map(item => [item.key, item.organizationId]))
  },
  sortedWarehouseOrganizations (state) {
    return state.warehouseOrganizations.map(item => {
      return {...item, displayName: `${item.organizationId} (${item.tenantName})`}
    }).sort(sortNoCase('organizationId'))
  },
  getWarehouseOrganizationsByKey (state) {
    return key => state.warehouseOrganizations.find(org => org.key === key)
  },
  tenantKey2BillingsMap (state) {
    return new Map(state.warehouseBillings.map(item => {
      let {tenantKey, ...rest} = item
      return [tenantKey, rest]
    }))
  },
  tenantsWithBillings (state, getters) {
    let organizations = state.warehouseOrganizations.filter(orgInfo => orgInfo.organizationKey !== 'unknown')
    return organizations.map(org => {
      let {key, isInboundWaived, isOutboundWaived, isStorageWaived} = org
      let waives = []
      isInboundWaived && (waives.push('inbound'))
      isOutboundWaived && (waives.push('outbound'))
      isStorageWaived && (waives.push('storage'))
      let billing = getters.tenantKey2BillingsMap.get(key)
      if (billing) {
        let {balance, expenseHistory, bond, lowestBalance, note} = billing
        return {...org, balance, expenseHistory, waives, bond, lowestBalance, note}
      }
      return {...org, balance: 0, waives}
    })
  },
  warehouseAnnouncements (state, getters) {
    return state.warehouseAnnouncements
  },
  packageReports (state, getters) {
    return state.packageReports
  },
  inboundTrackingCache (state, getters) {
    return state.inboundTrackingCache
  },
  abnormalPackages (state, getters) {
    return state.abnormalPackages
  },
  historyAbnormalPackages (state, getters) {
    return state.historyAbnormalPackages
  },
  statistics (state, getters) {
    return state.statistics
  },
  warehouseEmailTemplates (state, getters) {
    return state.warehouseLimitedInfo.emailTemplates
  },
  warehouseOrgSettings (state, getters) {
    return state.warehouseLimitedInfo.orgSettings
  },
  warehouseLimitedInfo (state, getters) {
    return state.warehouseLimitedInfo
  },
  tierDiscounts (state) {
    let {tierDiscounts} = state.warehouseLimitedInfo
    if (tierDiscounts) {
      return Object.keys(tierDiscounts).map(key => {
        let discount = tierDiscounts[key]
        let {name, discountRate} = discount
        return {displayName: `${name} (${discountRate}%)`, key, ...discount}
      })
    } else return []
  },
  activateSkuMode (state, getters) {
    return getters.activeOrganization || !!(getters.warehouseInfo &&
      getters.warehouseInfo.generalSettings &&
      getters.warehouseInfo.generalSettings.skuMode)
  },
  activateAdvancedOutboundMode (state, getters) {
    return !!(getters.warehouseInfo &&
      getters.warehouseInfo.generalSettings &&
      getters.warehouseInfo.generalSettings.advancedOutbound)
  },
  activatePrescan (state, getters) {
    return getters.activeOrganization || !!(getters.warehouseInfo &&
      getters.warehouseInfo.generalSettings &&
      getters.warehouseInfo.generalSettings.activatePrescan)
  },
  dailyInboundMap (state) {
    return state.dailyInboundMap
  },
  pickupRecords (state) {
    return state.pickupRecords
  },
  overseaCustomersList (state) {
    return state.overseaCustomersList
  },
  warehousePricingPlans (state) {
    return state.warehousePricingPlans || []
  },
  warehouseProducts (state, getters) {
    const products = state.warehouseProducts.map(product => {
      const {upc, organizationKey, sku} = product
      return {
        key: `warehouses/${getters.activeWarehouse}/organizations/${organizationKey}/products/${product._key}`,
        ...product,
        description: product.name,
        upc,
        approvedSkus: {[organizationKey]: [sku]},
        keywordForSearch: sku.join(', ')
      }
    })
    return products
  },
  thirdPartyResources (state) {
    return state.thirdPartyResources || []
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/warehouse/index.js